import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { db, auth, storage } from "../../../../backend/firebaseConfig";
import { doc, getDoc, updateDoc, deleteField, collection, query, where, getDocs, onSnapshot } from "firebase/firestore";
import {
  ref,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
  deleteObject,
  listAll,
} from "firebase/storage";
import {
  signOut,
  updatePassword,
  sendEmailVerification,
  onAuthStateChanged,
  reauthenticateWithCredential,
  EmailAuthProvider,
  verifyBeforeUpdateEmail,
} from "firebase/auth";
import TwoFactorModal from "../modal/TwoFactorModal";
import Modal from "react-modal";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// Imports MUI Components
import {
  Box,
  Button,
  Stack,
  Typography,
  Grid,
  Avatar,
  TextField,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormGroup,
  FormControlLabel,
  Switch,
  MenuItem,
  Snackbar,
  Alert as MuiAlert,
  IconButton,
  Tooltip,
  FormControl,
  Select as Selected
} from "@mui/material";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Close } from "@mui/icons-material";
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from "@mui/icons-material/Close";

// Import Organisms

// Import Molecules

// Import Assets
import profile from "../../../../assets/user.png";
import camera from "../../../../assets/camera.png";

// Import Atoms
import Text from "../../../../components/UI/atoms/text/Text";
import TextFieldComp from "../../../../components/UI/atoms/text-fields/TextField";
import Icon from "../../../../components/UI/atoms/icon/Icon";
import TextFieldCompV2 from "../../../../components/UI/atoms/text-fields/TextFieldComp";

import { redirectIfNotLoggedIn } from "../../../../components/functions/redirectIfNotLoggedIn";

import "./styles.css";
import AlertComp from "../../molecules/alert/AlertComp";

function formatDateMMDDYYYY(dateStr) {
  if (!dateStr) return "";
  const [year, month, day] = dateStr.split("-");
  return `${month}-${day}-${year}`;
}

// Add CSS keyframes for animations and disable browser password icons
const styles = `
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }
  
  /* Disable browser's default show password icons */
  input[type="password"]::-webkit-credentials-auto-fill-button,
  input[type="password"]::-webkit-strong-password-auto-fill-button {
    display: none !important;
  }
  
  input[type="password"]::-ms-reveal,
  input[type="password"]::-ms-clear {
    display: none !important;
  }
`;

// Inject styles into document head
if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Profile"); // Default to "Profile"
  const [user, setCurrentUser] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [isEditing, setIsEditing] = useState(false); // State to toggle edit mode
  const [editedDetails, setEditedDetails] = useState({}); // State to store edited values
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [currentPasswordAuthError, setCurrentPasswordAuthError] = useState("");
  const [newPasswordFieldError, setNewPasswordFieldError] = useState("");
  const [confirmPasswordFieldError, setConfirmPasswordFieldError] = useState("");
  const [touchedFields, setTouchedFields] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false
  });
  const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).+$/;
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [twoFactorMethods, setTwoFactorMethods] = useState([]); // Array of selected methods: ["email"] or []

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [show2FASnackbar, setShow2FASnackbar] = useState(false);
  const [twoFASnackbarMessage, setTwoFASnackbarMessage] = useState("");
  const [showEmailVerificationSnackbar, setShowEmailVerificationSnackbar] = useState(false);
  const [emailVerificationSnackbarMessage, setEmailVerificationSnackbarMessage] = useState("");
  const [showPasswordUpdateSnackbar, setShowPasswordUpdateSnackbar] = useState(false);
  const [profilePictureUrl, setProfilePictureUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState(null);
  const [show2FAModal, setShow2FAModal] = useState(false);
  const [pending2FAMethod, setPending2FAMethod] = useState(null); // Track pending method change

  const [showCustomAlert, setShowCustomAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  const [alertImage, setAlertImage] = useState("");
  const [alertButton, setAlertButton] = useState("");
  const [alertButtonType, setAlertButtonType] = useState("false");
  const [alertLink, setAlertLink] = useState("");
  const [showReauthModal, setShowReauthModal] = useState(false);
  const [reauthPassword, setReauthPassword] = useState("");
  const [reauthPasswordError, setReauthPasswordError] = useState("");
  const [reauthPromptMessage, setReauthPromptMessage] = useState(
    "Enter your current password to proceed."
  );
  const [showReauthPassword, setShowReauthPassword] = useState(false);
  const reauthPromiseRef = useRef(null);
  const [showEmailChangeModal, setShowEmailChangeModal] = useState(false);
  const [newEmailInput, setNewEmailInput] = useState("");
  const [emailChangePassword, setEmailChangePassword] = useState("");
  const [showEmailChangePassword, setShowEmailChangePassword] = useState(false);
  const [emailValidationErrors, setEmailValidationErrors] = useState({
    email: "",
    password: "",
  });
  const [resendCooldown, setResendCooldown] = useState(0);
  const countdownIntervalRef = useRef(null);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isPasswordSaving, setIsPasswordSaving] = useState(false);
  const [is2FASaving, setIs2FASaving] = useState(false);
  const [isOKButtonLoading, setIsOKButtonLoading] = useState(false);
  const [isProfileSaving, setIsProfileSaving] = useState(false);
  const [isProfileCanceling, setIsProfileCanceling] = useState(false);
  const [isProfileEditing, setIsProfileEditing] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    contactNumber: "",
  });

  // Original 2FA settings for comparison
  const [originalTwoFactorEnabled, setOriginalTwoFactorEnabled] =
    useState(false);
  const [originalTwoFactorMethods, setOriginalTwoFactorMethods] = useState([]);

  // Success/Error modals
  const [successModal, setSuccessModal] = useState({
    isOpen: false,
    message: "",
    title: "",
    verificationMethod: "",
  });
  const [errorModal, setErrorModal] = useState({ isOpen: false, message: "" });
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  const [isDeletingAccount, setIsDeletingAccount] = useState(false);
  const [isCancellingDelete, setIsCancellingDelete] = useState(false);
  const [showDeleteAccountErrorSnackbar, setShowDeleteAccountErrorSnackbar] = useState(false);
  const [showDeleteRequestSuccessSnackbar, setShowDeleteRequestSuccessSnackbar] = useState(false);
  const [showPendingRequestSnackbar, setShowPendingRequestSnackbar] = useState(false);

  const [showTooltip, setShowTooltip] = React.useState(true);
  const handleTooltipClose = () => {
    setShowTooltip(false);
  };


  // Function to check if email is verified
  const isEmailVerified = () => {
    if (!userDetails?.email) return false;
    return userDetails.emailVerified === "Yes" || userDetails.emailVerified === "MobileOnly";
  };

  // Function to check if 2FA settings have changed
  const has2FAChanges = () => {
    // Check if enabled status changed
    if (twoFactorEnabled !== originalTwoFactorEnabled) {
      return true;
    }

    // Check if methods changed (only if 2FA is enabled)
    if (twoFactorEnabled && originalTwoFactorEnabled) {
      const currentMethods = [...twoFactorMethods].sort();
      const originalMethods = [...originalTwoFactorMethods].sort();

      if (currentMethods.length !== originalMethods.length) {
        return true;
      }

      for (let i = 0; i < currentMethods.length; i++) {
        if (currentMethods[i] !== originalMethods[i]) {
          return true;
        }
      }
    }

    return false;
  };

  // For delete confirmation modal
  const [deleteModalConfig, setDeleteModalConfig] = useState({
    isOpen: false,
  });

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Fetch user details from the database
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user); // <-- store the whole user object

        // Email change logic is now handled globally in useAuth hook

        loadUserDetails(user.uid); // Fetch user details from the database
      } else {
        setCurrentUser(null);
        setUserDetails(null);
      }
    });

    return () => unsubscribe();
  }, []);

  // Set up real-time listener for user document changes (especially email verification status)
  useEffect(() => {
    if (!user?.uid) return;

    const userRef = doc(db, "users", user.uid);
    const currentUser = user; // Capture user reference
    
    // Set up real-time listener for user document
    const unsubscribeSnapshot = onSnapshot(
      userRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const userData = snapshot.data();
          
          // Update user details when document changes
          setUserDetails(userData);
          setProfilePictureUrl(userData.profilePictureUrl || null);

          // Load 2FA settings if they exist - ONLY update current state, NOT original
          // Original values should only be set on initial load and after successful save
          if (userData.twoFactorEnabled !== undefined) {
            setTwoFactorEnabled(userData.twoFactorEnabled);
            // DON'T update originalTwoFactorEnabled - it's only set on load/save
          } else {
            setTwoFactorEnabled(false);
            // DON'T update originalTwoFactorEnabled
          }

          if (userData.twoFactorMethod) {
            if (userData.twoFactorMethod.includes(",")) {
              const methods = userData.twoFactorMethod
                .split(",")
                .filter((m) => m.trim());
              setTwoFactorMethods(methods);
              // DON'T update originalTwoFactorMethods
            } else {
              setTwoFactorMethods([userData.twoFactorMethod]);
              // DON'T update originalTwoFactorMethods
            }
          } else {
            // If 2FA is enabled but no method set, automatically set email if verified
            if (userData.twoFactorEnabled && (userData.emailVerified === "Yes" || userData.emailVerified === "MobileOnly")) {
              setTwoFactorMethods(["email"]);
              // DON'T update originalTwoFactorMethods
            } else {
              setTwoFactorMethods([]);
              // DON'T update originalTwoFactorMethods
            }
          }

          // Reload Firebase Auth user to sync email verification status
          if (currentUser) {
            currentUser.reload().catch(console.error);
          }
        }
      },
      (error) => {
        if (error?.code !== "permission-denied") {
          console.error("Error listening to user document:", error);
        }
      }
    );

    return () => unsubscribeSnapshot();
  }, [user?.uid]);

  // Set up BroadcastChannel listener for email verification events
  useEffect(() => {
    const broadcastChannel = typeof BroadcastChannel !== 'undefined' 
      ? new BroadcastChannel('email_verification') 
      : null;

    if (broadcastChannel && user?.uid) {
      const currentUserId = user.uid;
      const currentUser = user;
      
      const handleMessage = async (event) => {
        if (event.data.type === 'email_verified' && currentUserId) {
          // Refresh user details when email is verified in another tab
          await loadUserDetails(currentUserId);
          
          // Reload Firebase Auth user
          if (currentUser) {
            await currentUser.reload();
          }
        }
      };

      broadcastChannel.addEventListener('message', handleMessage);

      return () => {
        broadcastChannel.removeEventListener('message', handleMessage);
        broadcastChannel.close();
      };
    }
  }, [user?.uid]);

  const loadUserDetails = async (uid) => {
    const userRef = doc(db, "users", uid);
    try {
      const snapshot = await getDoc(userRef);
      if (snapshot.exists()) {
        const userData = snapshot.data();
        setUserDetails(userData);
        setProfilePictureUrl(userData.profilePictureUrl || null);

        // Load 2FA settings if they exist - ensure proper state sync

        if (userData.twoFactorEnabled !== undefined) {
          setTwoFactorEnabled(userData.twoFactorEnabled);
          setOriginalTwoFactorEnabled(userData.twoFactorEnabled); // Store original value
        } else {
          setTwoFactorEnabled(false); // Default to false if not set
          setOriginalTwoFactorEnabled(false); // Store original value
        }

        if (userData.twoFactorMethod) {
          // Handle both single method and comma-separated multiple methods
          if (userData.twoFactorMethod.includes(",")) {
            const methods = userData.twoFactorMethod
              .split(",")
              .filter((m) => m.trim());
            setTwoFactorMethods(methods);
            setOriginalTwoFactorMethods([...methods]); // Store original value
          } else {
            setTwoFactorMethods([userData.twoFactorMethod]);
            setOriginalTwoFactorMethods([userData.twoFactorMethod]); // Store original value
          }
        } else {
          setTwoFactorMethods([]); // No methods selected by default
          setOriginalTwoFactorMethods([]); // Store original value
        }
      } else {
        setUserDetails(null);
        setProfilePictureUrl(null);
        setTwoFactorEnabled(false);
        setOriginalTwoFactorEnabled(false);
        setTwoFactorMethods([]);
        setOriginalTwoFactorMethods([]);
        try {
          if (auth.currentUser) {
            await signOut(auth);
          }
        } catch (signOutError) {
          if (signOutError?.code !== "auth/no-current-user") {
            console.error('Error signing out removed user:', signOutError);
          }
        }
        navigate('/sign-in', {
          state: {
            from: location.pathname,
            message: 'Your session has ended. Please sign in again.'
          },
          replace: true
        });
      }
    } catch (error) {
      if (error?.code === "permission-denied") {
        try {
          if (auth.currentUser) {
            await signOut(auth);
          }
        } catch (signOutError) {
          if (signOutError?.code !== "auth/no-current-user") {
            console.error('Error signing out removed user:', signOutError);
          }
        }
        navigate('/sign-in', {
          state: {
            from: location.pathname,
            message: 'Your session has ended. Please sign in again.'
          },
          replace: true
        });
      } else {
        console.error("Error fetching user details:", error.message);
      }
    }
  };

  // Handle logout
  const handleLogout = () => {
    signOut(auth).then(() => {
      navigate("/", { replace: true });
    });
  };

  // Handle input changes
  const handleInputChange = (field, payload) => {
    let value = payload;
    if (payload && payload.target && typeof payload.target.value !== "undefined") {
      value = payload.target.value;
    } else if (payload && typeof payload === "object" && "value" in payload) {
      value = payload.value;
    }

    // sanitize & validate by field
    if (field === "firstName" || field === "middleName" || field === "lastName") {
      // allow letters, spaces, hyphen and apostrophe
      const sanitized = String(value).replace(/[^a-zA-Z\s'-]/g, "");
      setEditedDetails((prev) => ({ ...prev, [field]: sanitized }));
      setFieldErrors((prev) => ({
        ...prev,
        [field]:
          sanitized !== String(value)
            ? "Only letters, spaces, dash and apostrophe are allowed."
            : "",
      }));
      return;
    }

    if (field === "contactNumber") {
      // digits only
      const raw = String(value);
      const digitsOnly = raw.replace(/\D/g, "");
      const limited = digitsOnly.slice(0, 11);
      setEditedDetails((prev) => ({ ...prev, [field]: limited }));
      
      // Validate: empty is okay (optional) IF user has no current number.
      // Otherwise require a NEW number different from current and exactly 11 digits starting with 09.
      let error = "";
      if (limited.length > 0 && !limited.startsWith('09')) {
        error = "Mobile number must start with '09'";
      } else if (limited.length > 0 && limited.length !== 11) {
        error = "Mobile number must be 11 digits (e.g., 09XXXXXXXXX)";
      } else if (userDetails?.contactNumber && userDetails.contactNumber.trim() !== "") {
        // User already has a mobile number: field cannot be empty or same as current
        if (limited.length === 0 || limited === userDetails.contactNumber) {
          error = "Please enter a new mobile number";
        }
      }
      
      setFieldErrors((prev) => ({
        ...prev,
        contactNumber: error,
      }));
      return;
    }

    // default behavior for other fields
    setEditedDetails((prev) => ({ ...prev, [field]: value }));
  };


  // Handle email change modal submission
  const handleEmailChangeSubmit = async () => {
    // Clear previous validation errors
    setEmailValidationErrors({ email: "", password: "" });

    let hasErrors = false;
    const newErrors = { email: "", password: "" };

    // Custom email format validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    // Validate new email
    if (!newEmailInput || newEmailInput.trim() === "") {
      newErrors.email = userDetails?.email ? "Please enter the new email address" : "Please enter an email address";
      hasErrors = true;
    } else if (!emailRegex.test(newEmailInput.trim())) {
      newErrors.email =
        "Please enter a valid email address format (e.g., user@example.com)";
      hasErrors = true;
    } else if (userDetails?.email && newEmailInput.trim() === userDetails?.email) {
      // Only check if same email when user already has an email (changing, not adding)
      newErrors.email = "Please enter a different email address";
      hasErrors = true;
    }

    // Validate password
    if (!emailChangePassword || emailChangePassword.trim() === "") {
      newErrors.password = "Please enter your password";
      hasErrors = true;
    }

    // If there are validation errors, show them and return
    if (hasErrors) {
      setEmailValidationErrors(newErrors);
      return;
    }

    const newEmail = newEmailInput.trim();
    
    // Check if email already exists in system
    try {
      const emailQuery = query(
        collection(db, "users"),
        where("email", "==", newEmail)
      );
      const emailSnapshot = await getDocs(emailQuery);
      
      // Also check pending email changes
      const pendingEmailQuery = query(
        collection(db, "users"),
        where("pendingEmailChange", "==", newEmail)
      );
      const pendingSnapshot = await getDocs(pendingEmailQuery);
      
      // Check if any user (except current user) has this email
      const existingEmailDoc = emailSnapshot.docs.find(doc => doc.id !== user.uid);
      const existingPendingDoc = pendingSnapshot.docs.find(doc => doc.id !== user.uid);
      
      if (existingEmailDoc || existingPendingDoc) {
        setEmailValidationErrors({
          email: "This email address is already in use by another account",
          password: ""
        });
        return;
      }
    } catch (checkError) {
      console.error("Error checking email availability:", checkError);
      // Continue with email change if check fails (don't block user)
    }

    try {
      const credential = EmailAuthProvider.credential(
        user.email,
        emailChangePassword
      );
      await reauthenticateWithCredential(user, credential);
      
      // Always use verifyBeforeUpdateEmail for email changes
      // Firebase requires verification before updating email regardless of current email status
      const actionCodeSettings = {
        url: `${window.location.origin}/verify-email`,
        handleCodeInApp: true,
      };

      await verifyBeforeUpdateEmail(user, newEmail, actionCodeSettings);

      // Store pending email in Firestore (will be synced after verification)
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, {
        pendingEmailChange: newEmail,
        emailChangeStatus: "pending",
        emailChangeTimestamp: Date.now(),
      });

      // Update local state
      setUserDetails((prev) => ({
        ...prev,
        pendingEmailChange: newEmail,
        emailChangeStatus: "pending",
        emailChangeTimestamp: Date.now(),
      }));

      // Set initial cooldown of 60 seconds after sending verification email
      setResendCooldown(60);

      // Start cooldown timer
      const timer = setInterval(() => {
        setResendCooldown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      countdownIntervalRef.current = timer;

      // Check if user is adding email for first time or changing it
      const isAddingEmail = !userDetails?.email || userDetails?.email === "";
      
      // Show snackbar instead of modal
      const message = isAddingEmail
        ? `A verification email has been sent to ${newEmail}. Please check your inbox and click the verification link to add your email.`
        : `A verification email has been sent to ${newEmail}. Please check your inbox and click the verification link to change your email.`;
      setEmailVerificationSnackbarMessage(message);
      setShowEmailVerificationSnackbar(true);

      // Clear form fields and close modal
      setNewEmailInput("");
      setEmailChangePassword("");
      setShowEmailChangeModal(false);
    } catch (error) {
      console.error("Email change error:", error);
      const code = error?.code || "";
      const msg = error?.message || "";

      // Handle specific errors with inline validation
      if (
        code === "auth/wrong-password" ||
        code === "auth/invalid-credential" ||
        /wrong-password|invalid-credential/i.test(msg)
      ) {
        setEmailValidationErrors({
          email: "",
          password: "Password is incorrect",
        });
        } else if (code === "auth/too-many-requests") {
          setEmailValidationErrors({
            email: "",
            password: "Too many attempts. Please try again later.",
          });
      } else if (code === "auth/email-already-in-use") {
        setEmailValidationErrors({
          email: "That email address is already in use",
          password: "",
        });
      } else if (
        code === "auth/invalid-email" ||
        code === "auth/invalid-new-email"
      ) {
        setEmailValidationErrors({
          email:
            "Please enter a valid email address format (e.g., user@example.com)",
          password: "",
        });
      } else if (code === "auth/operation-not-allowed") {
        setEmailValidationErrors({
          email:
            "Email change is currently disabled. Please contact your administrator to enable Email/Password sign-in in the Firebase Console (Authentication → Sign-in method)",
          password: "",
        });
      } else {
        setEmailValidationErrors({
          email: "Failed to change email. " + msg,
          password: "",
        });
      }
    }
  };

  // Handle closing email change modal and clearing form
  const handleEmailChangeModalClose = () => {
    setShowEmailChangeModal(false);
    setNewEmailInput("");
    setEmailChangePassword("");
    setEmailValidationErrors({ email: "", password: "" });
  };

  // Function to resend email verification
  const handleResendEmailChangeVerification = async () => {
    if (!user) return;

    // Check cooldown - show message if cooldown is active
    if (resendCooldown > 0) {
      // Don't show error modal, just return silently (button is already disabled)
      return;
    }

    // Set cooldown to 60 seconds (always 60s to match signup behavior)
    setResendCooldown(60);
    
    // Start countdown timer immediately
    const countdownInterval = setInterval(() => {
      setResendCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    countdownIntervalRef.current = countdownInterval;

    try {
      // Check if user has pending email change or unverified current email
      if (userDetails?.pendingEmailChange) {
        // Check if Firebase Auth email matches the pending email
        // If it does, the email is already updated in Firebase Auth, so use sendEmailVerification
        // If it doesn't, use verifyBeforeUpdateEmail to verify before updating
        const authEmail = user.email;
        const pendingEmail = userDetails.pendingEmailChange;
        
        if (authEmail === pendingEmail) {
          // Email is already updated in Firebase Auth, just needs verification
          await sendEmailVerification(user);
        } else {
          // Email needs to be updated in Firebase Auth first, then verified
          const actionCodeSettings = {
            url: `${window.location.origin}/verify-email`,
            handleCodeInApp: true,
          };
          await verifyBeforeUpdateEmail(user, pendingEmail, actionCodeSettings);
        }
      } else if (userDetails?.email && userDetails.emailVerified !== "Yes" && userDetails.emailVerified !== "MobileOnly") {
        // Resend verification for current unverified email
        await sendEmailVerification(user);
      } else {
        // If no email but Firebase Auth has an email, try to verify it
        if (user.email && user.emailVerified === false) {
          await sendEmailVerification(user);
        } else {
          // Clear cooldown if no email to verify
          clearInterval(countdownIntervalRef.current);
          setResendCooldown(0);
          return; // No email to verify
        }
      }

      // Email sent successfully - cooldown already set to 60s
      const emailToDisplay = userDetails?.pendingEmailChange || userDetails?.email || user.email;
      // Show snackbar instead of modal
      setEmailVerificationSnackbarMessage(`Verification email resent to ${emailToDisplay}. Please check your inbox and click the verification link.`);
      setShowEmailVerificationSnackbar(true);
    } catch (error) {
      console.error("Error resending verification email:", error);
      
      // Handle Firebase rate limiting errors - still use 60s cooldown
      if (error.code === "auth/too-many-requests") {
        // Keep the 60s cooldown that's already running
        // Don't show error modal - the cooldown will be visible in the UI
        return;
      }
      
      // Handle requires-recent-login error - sign out and redirect to login
      if (error.code === "auth/requires-recent-login") {
        // Clear cooldown
        if (countdownIntervalRef.current) {
          clearInterval(countdownIntervalRef.current);
        }
        setResendCooldown(0);
        
        // Sign out and redirect to login with state to show snackbar
        // Also store in sessionStorage as backup in case React Router doesn't detect navigation
        const sessionExpiredMessage = "Your session has expired. Please sign-in again to resend the verification email.";
        sessionStorage.setItem("sessionExpiredMessage", sessionExpiredMessage);
        
        try {
          await signOut(auth);
          navigate("/sign-in", { 
            replace: true,
            state: { 
              sessionExpired: true,
              message: sessionExpiredMessage
            }
          });
        } catch (signOutError) {
          console.error("Error signing out:", signOutError);
          // Still redirect even if sign out fails
          navigate("/sign-in", { 
            replace: true,
            state: { 
              sessionExpired: true,
              message: sessionExpiredMessage
            }
          });
        }
        
        return;
      }
      
      // Clear cooldown for other errors
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
      }
      setResendCooldown(0);
      
      // For other errors, show error modal
      setErrorModal({
        isOpen: true,
        message: "Failed to resend verification email. Please try again.",
      });
    }
  };

  // Function to resend email verification for current email
  const handleResendVerification = async () => {
    if (!user) return;

    try {
      await sendEmailVerification(user);
      // Show snackbar instead of modal
      setEmailVerificationSnackbarMessage(`Verification email sent to ${user.email}. Please check your inbox and click the verification link.`);
      setShowEmailVerificationSnackbar(true);
    } catch (error) {
      console.error("Error resending verification email:", error);
      
      // Handle requires-recent-login error - sign out and redirect to login
      if (error.code === "auth/requires-recent-login") {
        // Sign out and redirect to login with state to show snackbar
        // Also store in sessionStorage as backup in case React Router doesn't detect navigation
        const sessionExpiredMessage = "Your session has expired. Please sign-in again to resend the verification email.";
        sessionStorage.setItem("sessionExpiredMessage", sessionExpiredMessage);
        
        try {
          await signOut(auth);
          navigate("/sign-in", { 
            replace: true,
            state: { 
              sessionExpired: true,
              message: sessionExpiredMessage
            }
          });
        } catch (signOutError) {
          console.error("Error signing out:", signOutError);
          // Still redirect even if sign out fails
          navigate("/sign-in", { 
            replace: true,
            state: { 
              sessionExpired: true,
              message: sessionExpiredMessage
            }
          });
        }
        
        return;
      }
      
      // For other errors, show error modal
      setErrorModal({
        isOpen: true,
        message: "Failed to resend verification email. Please try again.",
      });
    }
  };

  // Helper function to delete all treatment images for a patient
  const deleteAllTreatmentImages = async (patientUid) => {
    if (!patientUid) return;

    const rootRef = storageRef(storage, `treatment-images/${patientUid}`);

    const deleteFolderRecursive = async (prefixRef) => {
      const { prefixes = [], items = [] } = await listAll(prefixRef);

      for (const item of items) {
        try {
          await deleteObject(item);
        } catch (error) {
          console.error("Error deleting storage object:", item.fullPath, error);
        }
      }

      for (const folderRef of prefixes) {
        await deleteFolderRecursive(folderRef);
      }
    };

    try {
      await deleteFolderRecursive(rootRef);
    } catch (error) {
      console.error("Error deleting treatment images for patient:", patientUid, error);
    }
  };

  // Helper function to delete appointment images
  const deletePatientAppointmentImages = async (patientUid) => {
    if (!patientUid) return;

    try {
      const appointmentsSnapshot = await getDocs(collection(db, "appointments"));
      const deletePromises = [];

      appointmentsSnapshot.forEach((docSnap) => {
        const appointmentsData = docSnap.data();
        if (!appointmentsData) return;

        Object.values(appointmentsData).forEach((appointment) => {
          if (!appointment) return;

          const appointmentPatientUid =
            appointment.patientId || appointment.uid || appointment.userId;

          if (appointmentPatientUid !== patientUid) return;

          if (Array.isArray(appointment.images)) {
            appointment.images.forEach((imageRef) => {
              const imagePath = imageRef?.path || imageRef?.storagePath;
              if (!imagePath) return;

              const fileRef = storageRef(storage, imagePath);
              deletePromises.push(
                deleteObject(fileRef).catch((error) => {
                  console.error(
                    "Failed to delete treatment image:",
                    imagePath,
                    error
                  );
                })
              );
            });
          }
        });
      });

      await Promise.all(deletePromises);
    } catch (error) {
      console.error(
        "Error removing patient treatment images from appointments:",
        error
      );
    }
  };

  // Helper function to create appointment date for comparison
  const createAppointmentDate = (dateStr = "", timeStr = "") => {
    const [yearStr, monthStr, dayStr] = dateStr.split("-");
    if (!yearStr || !monthStr || !dayStr) {
      return null;
    }

    const year = Number(yearStr);
    const monthIndex = Number(monthStr) - 1;
    const day = Number(dayStr);

    if (
      Number.isNaN(year) ||
      Number.isNaN(monthIndex) ||
      Number.isNaN(day) ||
      monthIndex < 0 ||
      monthIndex > 11
    ) {
      return null;
    }

    const extractTimePart = (timeStr = "", index = 0) => {
      if (!timeStr) return "";
      const parts = timeStr.split("-");
      if (parts.length > index) {
        return parts[index].trim();
      }
      return timeStr.trim();
    };

    const parseTimeTo24Hour = (timeStr = "") => {
      const extracted = extractTimePart(timeStr);
      const match = extracted.match(/^(\d{1,2}):(\d{2})(?:\s*(AM|PM))?$/i);

      if (!match) {
        return { hours: 0, minutes: 0 };
      }

      let hours = parseInt(match[1], 10);
      const minutes = parseInt(match[2], 10);
      const meridiem = match[3] ? match[3].toUpperCase() : null;

      if (meridiem === "PM" && hours !== 12) {
        hours += 12;
      }

      if (meridiem === "AM" && hours === 12) {
        hours = 0;
      }

      return {
        hours: Number.isNaN(hours) ? 0 : hours,
        minutes: Number.isNaN(minutes) ? 0 : minutes,
      };
    };

    const { hours, minutes } = parseTimeTo24Hour(timeStr);

    return new Date(year, monthIndex, day, hours, minutes);
  };

  // Function to handle delete account
  const handleDeleteAccount = () => {
    setShowDeleteAccountModal(true);
  };

  // Function to confirm account deletion
  const confirmDeleteAccount = async () => {
    if (!user) return;

    setIsDeletingAccount(true);

    try {
      const currentUser = auth.currentUser;
      if (!currentUser) {
        throw new Error("No authenticated user found.");
      }

      const patientUid = currentUser.uid;
      const userRole = userDetails?.role || userDetails?.userType;

      // Check if user is DentistOwner - they can delete immediately
      if (userRole === "DentistOwner") {
        // DentistOwner - proceed with immediate deletion
        // Get all appointments
        const appointmentsSnapshot = await getDocs(collection(db, "appointments"));
        const now = new Date();
        const appointmentsToDelete = [];

        // Find upcoming appointments (confirmed/pending) to delete
        appointmentsSnapshot.forEach((docSnap) => {
          const appointmentsData = docSnap.data();
          if (!appointmentsData) return;

          Object.entries(appointmentsData).forEach(([appointmentId, appointment]) => {
            if (!appointment) return;

            const appointmentPatientUid =
              appointment.patientId || appointment.uid || appointment.userId;

            if (appointmentPatientUid !== patientUid) return;

            const status = (appointment.status || "").toLowerCase();
            if (status !== "pending" && status !== "confirmed") {
              return;
            }

            const appointmentDateValue =
              appointment.date ||
              appointment.appointmentDate ||
              appointment.appointment_date;

            if (!appointmentDateValue) {
              return;
            }

            const appointmentDateTime = createAppointmentDate(
              appointmentDateValue,
              appointment.startTime || appointment.time
            );

            if (!appointmentDateTime || Number.isNaN(appointmentDateTime.getTime())) {
              return;
            }

            if (appointmentDateTime >= now) {
              appointmentsToDelete.push({ docId: docSnap.id, appointmentId, appointment });
            }
          });
        });

        // Delete upcoming appointments
        const appointmentDocUpdates = {};
        for (const { docId, appointmentId } of appointmentsToDelete) {
          if (!appointmentDocUpdates[docId]) {
            appointmentDocUpdates[docId] = [];
          }
          appointmentDocUpdates[docId].push(appointmentId);
        }

        // Update all appointment documents
        for (const [docId, appointmentIds] of Object.entries(appointmentDocUpdates)) {
          try {
            const appointmentDocRef = doc(db, "appointments", docId);
            const updateData = {};
            appointmentIds.forEach((appointmentId) => {
              updateData[appointmentId] = deleteField();
            });
            await updateDoc(appointmentDocRef, updateData);
          } catch (error) {
            console.error(`Error deleting appointments from document ${docId}:`, error);
          }
        }

        // Delete treatment images from completed appointments
        await deletePatientAppointmentImages(patientUid);
        await deleteAllTreatmentImages(patientUid);

        // Delete user account via Vercel API
        const idToken = await user.getIdToken();
        const response = await fetch('/api/delete-user', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          }
        });
        
        const result = await response.json();
        if (!response.ok || !result.success) {
          throw new Error(result.message || "Failed to delete user account");
        }

        // Sign out and redirect to home page
        await signOut(auth);
        navigate("/", { replace: true });
      } else {
        // All other roles (Patient, Dentist, etc.) - request approval from DentistOwner
        const idToken = await user.getIdToken();
        const response = await fetch('/api/request-account-deletion', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
          },
          body: JSON.stringify({
            reason: "User requested account deletion"
          })
        });
        
        const result = await response.json();
        if (!response.ok || !result.success) {
          throw new Error(result.message || "Failed to submit deletion request");
        }

        // Close modal and show success message
        setShowDeleteAccountModal(false);
        setIsDeletingAccount(false);
        setShowDeleteRequestSuccessSnackbar(true);
      }
    } catch (error) {
      console.error("Error deleting account:", error);
      
      // Show specific error message for pending requests
      if (error.message.includes("already have a pending") || error.message.includes("pending request")) {
        setShowPendingRequestSnackbar(true);
      } else {
        setShowDeleteAccountErrorSnackbar(true);
      }
      
      setIsDeletingAccount(false);
      setShowDeleteAccountModal(false);
    }
  };

  // Function to cancel account deletion
  const cancelDeleteAccount = async () => {
    setIsCancellingDelete(true);
    
    // Add a small delay to show loading state
    await new Promise(resolve => setTimeout(resolve, 300));
    
    setShowDeleteAccountModal(false);
    setIsCancellingDelete(false);
  };

  // Handle save changes
  const handleSave = async () => {
     if (!user) return;
    
    // Always validate firstName and lastName first - they cannot be empty
    // Get the final values: use edited value if it exists, otherwise use original value
    const finalFirstName = editedDetails.firstName !== undefined 
      ? (editedDetails.firstName || "")
      : (userDetails?.firstName || "");
    const finalLastName = editedDetails.lastName !== undefined 
      ? (editedDetails.lastName || "")
      : (userDetails?.lastName || "");

    const newErrors = { ...fieldErrors };
    let hasValidationErrors = false;

    // Check if firstName is empty (must have non-whitespace content)
    if (!finalFirstName || finalFirstName.trim() === "") {
      newErrors.firstName = "Please enter your first name";
      hasValidationErrors = true;
    } else {
      // Clear firstName error if it's valid
      newErrors.firstName = "";
    }

    // Check if lastName is empty (must have non-whitespace content)
    if (!finalLastName || finalLastName.trim() === "") {
      newErrors.lastName = "Please enter your last name";
      hasValidationErrors = true;
    } else {
      // Clear lastName error if it's valid
      newErrors.lastName = "";
    }

    // Check for other field errors (excluding firstName/lastName which we just validated)
    const otherErrors = Object.entries(newErrors)
      .filter(([key]) => key !== "firstName" && key !== "lastName")
      .some(([, value]) => value && value.length);

    // If validation errors exist (firstName/lastName or other), set them and prevent saving
    if (hasValidationErrors || otherErrors) {
      setFieldErrors(newErrors);
      return;
    }

    setIsProfileSaving(true);
    
    // Add a small delay to show loading state
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const userRef = doc(db, "users", user.uid);

    // Merge edited details with existing user details
    const updatedDetails = {
      ...userDetails, // Existing user data
      ...editedDetails, // Only the fields that were edited
    };

    // Only remove email from updated details if it was actually edited
    // This prevents email from disappearing when no changes are made
    if (editedDetails.email !== undefined) {
      delete updatedDetails.email;
    }

    try {
      // Handle mobile number changes (including removal - empty string)
      const hasContactNumberChanged = editedDetails.contactNumber !== undefined && 
                                     editedDetails.contactNumber !== (userDetails.contactNumber || "");
      
      if (hasContactNumberChanged) {
        const newContactNumber = editedDetails.contactNumber || ""; // Handle empty string
        
        // If user is attempting to remove mobile (setting to empty)
        if (newContactNumber === "") {
          // Do NOT allow removal if a mobile number already exists
          if (userDetails?.contactNumber && userDetails.contactNumber.trim() !== "") {
            setIsProfileSaving(false);
            setFieldErrors((prev) => ({
              ...prev,
              contactNumber: "Please enter a new mobile number",
            }));
            return;
          }
          // If there's no existing mobile, allow leaving it empty (no change)
          updatedDetails.contactNumber = "";
          updatedDetails.mobile = "";
        } else {
          // User is adding/changing mobile number
          // Check if mobile number already exists in system
          const mobileQuery = query(
            collection(db, "users"),
            where("mobile", "==", newContactNumber)
          );
          const mobileSnapshot = await getDocs(mobileQuery);
          
          // Check if any user (except current user) has this mobile number
          const existingMobileDoc = mobileSnapshot.docs.find(doc => doc.id !== user.uid);
          
          if (existingMobileDoc) {
            setIsProfileSaving(false);
            setFieldErrors((prev) => ({
              ...prev,
              contactNumber: "This mobile number is already in use by another account"
            }));
            return;
          }
          
          // Require password reauthentication for changing mobile number
          const pwdPhone = await promptForCurrentPassword(
            "Please enter your current password to change your mobile number."
          );
          if (!pwdPhone) {
            setIsProfileSaving(false);
            return;
          }
          const credentialPhone = EmailAuthProvider.credential(
            user.email,
            pwdPhone
          );
          await reauthenticateWithCredential(user, credentialPhone);
          setCurrentPassword("");
          
          // Ensure both contactNumber AND mobile fields are updated
          updatedDetails.contactNumber = newContactNumber;
          updatedDetails.mobile = newContactNumber;
        }
      }

      // Write merged details to Firestore
      await updateDoc(userRef, updatedDetails);

      setUserDetails(updatedDetails); // Update local state with the new data
      setIsEditing(false); // Exit edit mode
      setShowSuccessMessage(true); // Show success message
      // Hide success message after 3 seconds
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 3000);
    } catch (error) {
      console.error("Save profile error:", error);
      const code = error?.code || "";
      const msg = error?.message || "";

      if (
        code === "auth/wrong-password" ||
        code === "auth/invalid-credential" ||
        /wrong-password|invalid-credential/i.test(msg)
      ) {
        setErrorModal({
          isOpen: true,
          message: "Password is incorrect",
        });
      } else {
        setErrorModal({
          isOpen: true,
          message: "Failed to save profile. " + msg,
        });
      }
    } finally {
      setIsProfileSaving(false);
    }
  };

  // Handle profile picture upload
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type - only allow JPG, PNG, or SVG
    const allowedMimeTypes = ["image/jpeg", "image/jpg", "image/png", "image/svg+xml"];
    const allowedExtensions = [".jpg", ".jpeg", ".png", ".svg"];

    const fileType = (file.type || "").toLowerCase();
    const fileName = (file.name || "").toLowerCase();
    const hasAllowedExtension = allowedExtensions.some((ext) =>
      fileName.endsWith(ext)
    );

    if (!allowedMimeTypes.includes(fileType) || !hasAllowedExtension) {
      setUploadError("Only JPG, PNG, or SVG files are allowed.");
      return;
    }

    // Validate file size (5MB limit)
    if (file.size > 5 * 1024 * 1024) {
      setUploadError("Image size must be less than 5MB.");
      return;
    }

    setIsUploading(true);
    setUploadError(null);

    try {
      // Delete old profile picture if it exists
      if (
        profilePictureUrl &&
        profilePictureUrl !== "https://via.placeholder.com/50"
      ) {
        try {
          const oldImageRef = ref(storage, profilePictureUrl);
          await deleteObject(oldImageRef);
        } catch (error) {
          // Old image not found or already deleted
        }
      }

      // Upload new image
      const timestamp = Date.now();
      const fileName = `profile_${user.uid}_${timestamp}.jpg`;
      const imageRef = ref(storage, `profile-pictures/${user.uid}/${fileName}`);

      const snapshot = await uploadBytes(imageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);

      // Update user profile in Firestore
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, {
        profilePictureUrl: downloadURL,
      });

      // Update local state
      setProfilePictureUrl(downloadURL);
      setUserDetails((prev) => ({ ...prev, profilePictureUrl: downloadURL }));

      setUploadError(null);

      // Reset the file input to allow re-uploading the same file
      event.target.value = "";
    } catch (error) {
      console.error("Error uploading image:", error);
      setUploadError("Failed to upload image. Please try again.");
      // Reset the file input on error as well
      event.target.value = "";
    } finally {
      setIsUploading(false);
    }
  };

  // Handle drag and drop
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Function to validate password (matching Update Password modal validation)
  const validatePassword = (password) => {
    if (!password) return "Password is required";
    if (password.length < 8) return "Password must be at least 8 characters long";
    if (!passwordPattern.test(password)) {
      return "Password must contain an uppercase letter, a lowercase letter, a number, and a special character";
    }
    return "";
  };

  // Function to validate confirm password
  const validateConfirmPassword = (confirmPasswordValue, newPasswordValue) => {
    if (!confirmPasswordValue) return "";
    if (confirmPasswordValue !== newPasswordValue) return "Passwords do not match";
    return "";
  };

  // Inline validation messages for the password fields
  // Current password validation is handled via currentPasswordAuthError state

  // New password validation includes policy + must differ from current password
  const newPasswordError = (() => {
    // Don't show required error here - it's handled by newPasswordFieldError state
    if (!newPassword) return "";
    const policyError = validatePassword(newPassword);
    if (policyError) return policyError;
    // Only check if new password matches current password if current password has a value
    if (currentPassword.trim() && newPassword === currentPassword)
      return "New password cannot be the same as the current password";
    return "";
  })();

  const confirmPasswordError = (() => {
    // Don't show required error here - it's handled by confirmPasswordFieldError state
    if (!confirmPassword) return "";
    return validateConfirmPassword(confirmPassword, newPassword);
  })();

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      const fakeEvent = { target: { files: [file] } };
      handleImageUpload(fakeEvent);
    }
  };

  // Handle image deletion
  const handleImageDelete = async () => {
    if (
      !profilePictureUrl ||
      profilePictureUrl === "https://via.placeholder.com/50"
    )
      return;

    setDeleteModalConfig({ isOpen: true });
  };

  // Confirm image deletion
  const handleConfirmDelete = async () => {
    try {
      // Delete from storage
      const imageRef = ref(storage, profilePictureUrl);
      await deleteObject(imageRef);

      // Update user profile in Firestore
      const userRef = doc(db, "users", user.uid);
      await updateDoc(userRef, {
        profilePictureUrl: null,
      });

      // Update local state
      setProfilePictureUrl(null);
      setUserDetails((prev) => ({ ...prev, profilePictureUrl: null }));

      // Reset the file input to allow re-uploading after deletion
      const fileInput = document.getElementById("profile-image-upload");
      if (fileInput) {
        fileInput.value = "";
      }

      // Close modal
      setDeleteModalConfig({ isOpen: false });
    } catch (error) {
      console.error("Error deleting image:", error);
      setUploadError("Failed to delete image. Please try again.");
      setDeleteModalConfig({ isOpen: false });
    }
  };

  // Close delete confirmation modal
  const closeDeleteModal = () => {
    setDeleteModalConfig({ isOpen: false });
  };

  const boxStylesContent = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // height: "100vh",
    backgroundColor: "#FDF9F3",
    // width: "100%"
  };

  const styleTabsContainer = {
    justifyContent: "start",
    alignItems: "center",
    padding: "0 0 20px 0",
    margin: "0 30px",
    width: "calc(100% - 60px)",
    borderBottom: "1px solid rgba(89, 84, 74, .2)",
  };

  const typographyStylesH2 = {
    color: "#C5A572",
  };

   const styleTextSelect = {
    color: "#2C251E",
    fontWeight: "100",
    fontSize: "14px",
    padding: "5px 0",
  };

  // Call this to prompt the user for their current password. Resolves to the password (string) or null if cancelled.
  const promptForCurrentPassword = (
    message = "Enter your current password to proceed."
  ) =>
    new Promise((resolve) => {
      reauthPromiseRef.current = resolve;
      setReauthPassword("");
      setReauthPromptMessage(message);
      setShowReauthModal(true);
    });

  const handleReauthSubmit = async (e) => {
    e && e.preventDefault && e.preventDefault();
    if (!reauthPassword) {
      setReauthPasswordError("Please enter your password");
      return;
    }

    try {
      const credential = EmailAuthProvider.credential(
        user.email,
        reauthPassword
      );
      await reauthenticateWithCredential(user, credential);

      // Success: close modal and resolve with the confirmed password
      setShowReauthModal(false);
      reauthPromiseRef.current && reauthPromiseRef.current(reauthPassword);
      reauthPromiseRef.current = null;
      setReauthPassword("");
      setReauthPasswordError("");
    } catch (err) {
      const code = err?.code || "";
      const msg = err?.message || "";
      if (
        code === "auth/wrong-password" ||
        code === "auth/invalid-credential" ||
        /wrong-password|invalid-credential/i.test(msg)
      ) {
        setReauthPasswordError("Password is incorrect");
      } else if (code === "auth/too-many-requests") {
        setReauthPasswordError("Too many attempts. Please try again later.");
      } else {
        setReauthPasswordError("Failed to confirm password. Please try again.");
      }
    }
  };

  const handleReauthCancel = () => {
    setShowReauthModal(false);
    reauthPromiseRef.current && reauthPromiseRef.current(null);
    reauthPromiseRef.current = null;
  };

  // UseEffects
  useEffect(() => {
    // const details = fetchUserDetails(setUserDetails);
    const redirect = redirectIfNotLoggedIn(setShowCustomAlert, navigate);

    // Force refresh user data when component mounts to sync any auth changes
    if (user) {
      loadUserDetails(user.uid);
    }

    // const notify = notifyFirstUser();
    return () => {
      // details && details();
      redirect && redirect();
      // notify && notify();
    };
  }, [user]);

  // Cleanup countdown interval on unmount
  useEffect(() => {
    return () => {
      if (countdownIntervalRef.current) {
        clearInterval(countdownIntervalRef.current);
      }
    };
  }, []);

  // Periodic check for expired email changes (every 5 minutes)
  useEffect(() => {
    if (
      !userDetails?.emailChangeStatus ||
      userDetails.emailChangeStatus !== "pending"
    ) {
      return;
    }

    const checkExpiration = async () => {
      if (userDetails.emailChangeTimestamp) {
        const now = Date.now();
        const twoDays = 2 * 24 * 60 * 60 * 1000; // 2 days in milliseconds

        if (now - userDetails.emailChangeTimestamp > twoDays) {
          // Update local state to reflect expiration
          setUserDetails((prev) => ({
            ...prev,
            emailChangeStatus: "expired",
            pendingEmailChange: null,
            emailChangeTimestamp: null,
            emailChangeCancellationToken: null,
          }));
        }
      }
    };

    // Check immediately
    checkExpiration();

    // Set up periodic check every 5 minutes
    const interval = setInterval(checkExpiration, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, [userDetails?.emailChangeStatus, userDetails?.emailChangeTimestamp]);

  const tooltipContent = (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        width: "300px",
        pb: "5px",
        zIndex: "1"
      }}
    >
      <Stack
        direction="column"
        width="100%">
          <Box
            sx={{
          width: "100%",
          display: "flex",
          textAlign: "end",
          justifyContent: "end",
        }}>
      <IconButton
        size="small"
        onClick={handleTooltipClose}
        sx={{
          color: "#FEFEFE",
          padding: "2px",
          "&:hover": { opacity: 0.8 },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      </Box>
      <Stack
        direction="column"
        spacing={1}
        sx={{
          borderRadius: "8px",
              backgroundColor: "#FDF9F3",
        }}
        width="100%">
          <Box
            sx={{
              justifyContent: "center",
              textAlign: "center",
              pt: "10px"
            }}>
      <Typography variant="importantTitle">
        Email Change Pending Verification
      </Typography>
      </Box>
      <Stack
        spacing={1}
        >
          <Box
            sx={{
              pl: "10px",
              pt: "10px",
              borderRadius: "8px"
            }}>
              <Stack
                direction="row" spacing={1}>
      <Typography variant="importantLabel">
        New Email:
      </Typography>
      <Typography variant="importantLabelBold">
        {userDetails?.pendingEmailChange}
      </Typography>
      </Stack>
      </Box>
      <Box
            sx={{
              pr: "10px",
              pl: "10px",
              pt: "5px",
              borderRadius: "8px"
            }}>
      <Typography variant="importantLabelLight">
        Check your new email inbox and click the verification link to complete the change
      </Typography>
      </Box>
      <Box
            sx={{
              pt: "5px",
              pr: "10px",
              pl: "10px",
              pb: "5px",
              backgroundColor: "#ac8b33ff",
              borderBottomLeftRadius: "8px",
              borderBottomRightRadius: "8px"
            }}>
      <Typography variant="importantLabelItalic">
       If you change your mind, the verification link will automatically expire within a couple of days.
      </Typography>
      </Box>
      </Stack>
      </Stack>
      </Stack>
    </Box>
  );

  const styleText = {
    color: '#2C251E',
    fontWeight: '100',
    fontSize: '14px',
    padding: '5px 0',
  };

  return (
    <div>
      {/* All Content */}
      <Box sx={boxStylesContent}>
        {/*Grids */}
        <Grid
          container
          // rowSpacing={2}
          // columnSpacing={2}
          sx={{
            width: "100%",
            // height: "100vh",
            // backgroundColor: "blue",
            "& .MuiGrid-item": {
              display: "flex",
              justifyContent: "center",
              // backgroundColor: "blue",
            },
          }}
        >
          {/* Main Content */}
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12,
            }}
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              // boxShadow: "-1px 5px 10px rgba(0,0,0,0.25)",
              height: "calc(100vh - 115px)", // 👈 fills height below the header (adjust 80px if header height changes)
              overflow: "auto",
              mt: "0px",
            }}
          >
            {/* Main Content */}
            <Box
              sx={{
                width: "100%",
                backgroundColor: "#FDF9F3",
                height: "100%",
              }}
            >
              <Stack>
                <Box sx={{ width: "100%" }}>
                  <Box sx={{ borderColor: "rgba(89, 84, 74, 0.2)" }}>
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      aria-label="tabs"
                      TabIndicatorProps={{ style: { display: "none" } }}
                      sx={styleTabsContainer}
                    >
                      {[0, 1].map((idx) => (
                        <Tab
                          key={idx}
                          label={`${["Profile", "Security"][idx]}`}
                          {...a11yProps(idx)}
                          disabled={isEditing}
                          sx={{
                            backgroundColor:
                              value === idx
                                ? "rgba(89, 84, 74, 0.2)"
                                : "transparent",
                            color: "#59544A",
                            borderRadius: "10px",
                            padding: "10px 15px",
                            textTransform: "none",
                            fontWeight: value === idx ? 600 : 300,
                            ml: "20px",
                            transition: "all 0.3s",
                            ":hover": {
                              backgroundColor: "rgba(89, 84, 74, 0.6)",
                              color: "#FDF9F3",
                              // fontWeight: 600,
                            },
                            "&.Mui-selected": {
                              color: "#2C251E", // <-- force selected text to black
                            },
                          }}
                        />
                      ))}
                    </Tabs>
                  </Box>

                  <CustomTabPanel value={value} index={0}>


                    <Box
                      sx={{
                        padding: "20px 30px",
                        // target interactive elements explicitly so we don't accidentally block the edit button
                        '&.readonly-mode input, &.readonly-mode textarea, &.readonly-mode select, &.readonly-mode button, &.readonly-mode a, &.readonly-mode .MuiSwitch-root, &.readonly-mode .MuiCheckbox-root, &.readonly-mode .MuiRadio-root, &.readonly-mode .MuiSelect-root, &.readonly-mode .MuiOutlinedInput-root, &.readonly-mode .MuiButtonBase-root': {
                          pointerEvents: 'none',
                          userSelect: 'none',
                        },
                        // allow clicks for elements explicitly marked with .allow-click (and their children)
                        '&.readonly-mode .allow-click, &.readonly-mode .allow-click *': {
                          pointerEvents: 'auto !important',
                          userSelect: 'auto',
                        },
                     }}
                      className={!isEditing ? 'readonly-mode' : ''}
                    >

                    <Stack
                      direction={{
                        xs: "column",
                        sm: "column",
                        md: "column",
                        lg: "row",
                        xl: "row",
                      }}
                      spacing={2}
                      // backgroundColor="cadetblue"
                      height="calc(100vh - 280px)">
                        {/* Profile Picture */}
                        <Box
                          className="allow-click"
                          sx={{
                            backgroundColor: "#FEFEFE",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                            minWidth: "220px",
                            height: "90%",
                            borderRadius: 3,
                            padding: "30px",
                            textAlign: "center",
                          }}
                        >
                          <Box>
                            <Box
                              sx={{
                                position: "relative",
                                display: "inline-block",
                                marginBottom: "15px",
                              }}
                            >
                              {/* Profile Image */}
                              <Box
                                onDragOver={handleDragOver}
                                onDrop={handleDrop}
                                onClick={() =>
                                  document
                                    .getElementById("profile-image-upload")
                                    .click()
                                }
                                sx={{
                                  borderRadius: "50%",
                                  border: "4px solid #59544A",
                                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                                  overflow: "hidden",
                                  position: "relative",
                                  cursor: "pointer",
                                  height: "200px",
                                  width: "200px",
                                  background: "#000000",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  transition: "all 0.3s ease",
                                }}
                                onMouseEnter={(e) => {
                                  e.target.style.transform = "scale(1.02)";
                                }}
                                onMouseLeave={(e) => {
                                  e.target.style.transform = "scale(1)";
                                }}
                              >
                                {profilePictureUrl ? (
                                  <Box>
                                    <Avatar
                                      alt="Profile"
                                      sx={{
                                        width: "200px",
                                        height: "200px",
                                        border: "3px solid #59544A",
                                      }}
                                      src={
                                        userDetails?.profilePictureUrl
                                          ? userDetails.profilePictureUrl
                                          : user
                                      }
                                    />

                                    <label
                                      // htmlFor="profile-image-upload"
                                      style={{
                                        position: "absolute",
                                        bottom: "0",
                                        right: "0",
                                        background: "#2E2D2D",
                                        color: "white",
                                        border: "none",
                                        // borderRadius: "50px",
                                        width: "100%",
                                        height: "25%",
                                        cursor: isUploading
                                          ? "not-allowed"
                                          : "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "18px",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                                        transition: "all 0.2s ease",
                                        opacity: isUploading ? 0.6 : 1,
                                      }}
                                      title="Upload new profile picture"
                                    >
                                      <Icon src={camera} size="small" />
                                    </label>
                                  </Box>
                                ) : (
                                  <Box
                                    sx={{
                                      backgroundColor: isEditing
                                        ? "rgba(44, 37, 30, .7)"
                                        : "#2C251E",
                                      // borderRadius: "10px",
                                      width: "100%",
                                      height: "100%",
                                      padding: "30px",
                                      alignContent: "center",
                                      textAlign: "center",
                                    }}
                                  >
                                    <Icon src={profile} size="user-image" />

                                    <label
                                      // htmlFor="profile-image-upload"
                                      style={{
                                        position: "absolute",
                                        bottom: "0",
                                        right: "0",
                                        background: "#2E2D2D",
                                        color: "white",
                                        border: "none",
                                        // borderRadius: "50px",
                                        width: "100%",
                                        height: "25%",
                                        cursor: isUploading
                                          ? "not-allowed"
                                          : "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "18px",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                                        transition: "all 0.2s ease",
                                        opacity: isUploading ? 0.6 : 1,
                                      }}
                                      title="Upload new profile picture"
                                    >
                                      <Icon src={camera} size="small" />
                                    </label>
                                  </Box>
                                )}

                                {/* Upload Overlay */}
                                <div
                                  style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    background: "rgba(0,0,0,0.7)",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    opacity: 0,
                                    transition: "opacity 0.3s ease",
                                    cursor: "pointer",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.target.style.opacity = 1)
                                  }
                                  onMouseLeave={(e) =>
                                    (e.target.style.opacity = 0)
                                  }
                                >
                                  <span
                                    style={{
                                      color: "white",
                                      fontSize: "16px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {isUploading
                                      ? "Uploading..."
                                      : "Click to Upload"}
                                  </span>
                                </div>
                              </Box>

                              {/* Upload Button */}
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,.svg"
                                onChange={handleImageUpload}
                                disabled={isUploading}
                                style={{ display: "none" }}
                                id="profile-image-upload"
                                key={`upload-${
                                  profilePictureUrl ? "has-image" : "no-image"
                                }-${Date.now()}`}
                              />

                              {/* Delete Button (always show if image exists) */}
                              {profilePictureUrl &&
                                profilePictureUrl !==
                                  "https://via.placeholder.com/50" && (
                                  <button
                                    className="allow-click"
                                    onClick={handleImageDelete}
                                    disabled={isUploading}
                                    style={{
                                      position: "absolute",
                                      top: "10px",
                                      right: "10px",
                                      background: "#dc3545",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "50%",
                                      width: "35px",
                                      height: "35px",
                                      cursor: isUploading
                                        ? "not-allowed"
                                        : "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "16px",
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                                      transition: "all 0.2s ease",
                                      opacity: isUploading ? 0.6 : 1,
                                    }}
                                    onMouseEnter={(e) => {
                                      if (!isUploading) {
                                        e.target.style.transform = "scale(1.1)";
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.transform = "scale(1)";
                                    }}
                                    title="Remove profile picture"
                                  >
                                    ×
                                  </button>
                                )}
                            </Box>

                            <Text
                              variant="headerh2"
                              text={
                                userDetails
                                  ? `${userDetails.firstName} ${userDetails.middleName} ${userDetails.lastName}`
                                  : ""
                              }
                            />

                            <Text
                              variant="body1"
                              text={userDetails ? (userDetails.email || userDetails.pendingEmailChange || "") : ""}
                            />

                            {/* <Text
                              text={userDetails.email}
                              variant="h2"/> */}

                            {/* Upload Instructions */}
                            <div
                              style={{
                                textAlign: "center",
                                margin: "20px 0",
                                padding: "15px",
                                background: "#f8f9fa",
                                borderRadius: "8px",
                                border: "2px dashed #dee2e6",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "14px",
                                  color: "#666",
                                  marginBottom: "8px",
                                }}
                              >
                                <strong>Profile Picture Upload</strong>
                              </div>

                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#888",
                                  lineHeight: "1.4",
                                }}
                              >
                                • Click the camera icon or drag & drop an image
                                <br />
                                • Supported formats: JPG, PNG, or SVG
                                <br />
                                • Max size: 5MB
                              </div>
                            </div>

                            {/* Upload Error */}
                            {uploadError && (
                              <div
                                style={{
                                  textAlign: "center",
                                  color: "#dc3545",
                                  fontSize: "14px",
                                  marginBottom: "15px",
                                  padding: "10px",
                                  background: "#f8d7da",
                                  border: "1px solid #f5c6cb",
                                  borderRadius: "5px",
                                }}
                              >
                                {uploadError}
                              </div>
                            )}

                            {/* Upload Progress */}
                            {isUploading && (
                              <div
                                style={{
                                  textAlign: "center",
                                  marginBottom: "15px",
                                }}
                              >
                                <div
                                  style={{
                                    width: "200px",
                                    height: "4px",
                                    background: "#e9ecef",
                                    borderRadius: "2px",
                                    margin: "0 auto 8px auto",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      background: "#007BFF",
                                      animation: "pulse 1.5s infinite",
                                    }}
                                  />
                                </div>

                                <span
                                  style={{ fontSize: "12px", color: "#666" }}
                                >
                                  Uploading profile picture...
                                </span>
                              </div>
                            )}
                          </Box>
                        </Box>

        {/*Grids */}
        <Grid
          container
          // rowSpacing={2}
          // columnSpacing={2}
          sx={{
            width: "100%",
            // height: "100vh",
            // backgroundColor: "blue",
            "& .MuiGrid-item": {
              display: "flex",
              justifyContent: "center",
              // backgroundColor: "blue",
            },
          }}
        >
          {/* Main Content */}
          <Grid
            size={{
              xs: 12,
              sm: 12,
              md: 12,
              lg: 12,
              xl: 12,
            }}
            item
            sx={{
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                            borderRadius: 3,
              // height: "calc(100vh - 115px)", // 👈 fills height below the header (adjust 80px if header height changes)
              // overflow: "auto",
              mt: "0px",
            }}
          >
                        {/* Personal Information */}
                        <Grid
                          container
                          // rowSpacing={2}
                          // columnSpacing={2}
                          sx={{
                            width: "100%",
                            height: "100%",
                            // backgroundColor: "blue",
                            padding: "40px",
                            backgroundColor: "#FEFEFE",
                            // boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                            borderRadius: 3,
                            "& .MuiGrid-item": {
                              display: "flex",
                              justifyContent: "center",
                              // backgroundColor: "blue",
                            },
                          }}
                        >
                          <Grid
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            item
                          >  
                          <Text
                            text="Personal Information"
                            variant="headerh2"
                          />
                            {/* Personal Details */}
                            <Box
                              sx={{
                                // backgroundColor: "#be8d49ff",
                                margin: "20px 0",
                              }}
                            >
                              {/* Profile Information */}
                              {userDetails ? (
                                <div>
                                  {/*Grids */}
                                  <Grid
                                    container
                                    rowSpacing={2}
                                    columnSpacing={3}
                                    sx={{
                                      width: "100%",
                                      // height: "100vh",
                                      // backgroundColor: "blue",
                                      backgroundColor: "#FEFEFE",
                                      // boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                                      borderRadius: 3,
                                      "& .MuiGrid-item": {
                                        display: "flex",
                                        justifyContent: "center",
                                        // backgroundColor: "blue",
                                      },
                                    }}
                                  >
                                    {/* First Name Container*/}
                                    <Grid
                                      size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 4,
                                        xl: 4,
                                      }}
                                      item
                                    >
                                      {/* First Name */}
                                      <TextFieldComp
                                        id="firstName"
                                        label="First Name"
                                        type="text"
                                        value={
                                          isEditing
                                            ? editedDetails.firstName ??
                                              userDetails.firstName ??
                                              ""
                                            : userDetails.firstName ?? ""
                                        }
                                        color="primary"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "firstName",
                                            e.target ? e.target.value : e
                                          )
                                        }
                                        state={!isEditing}
                                        special={true}
                                      ></TextFieldComp>            
                                   {fieldErrors.firstName && (
                                     <div style={{ color: "#dc3545", fontSize: 12, marginTop: 6 }}>
                                       {fieldErrors.firstName}
                                     </div>
                                   )}
                                    </Grid>

                                    {/* Middle Name Container*/}
                                    <Grid
                                      size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 4,
                                        xl: 4,
                                      }}
                                      item
                                    >
                                      {/* Middle Name */}
                                      <TextFieldComp
                                        id="middleName"
                                        label="Middle Name"
                                        type="text"
                                        value={
                                          isEditing
                                            ? editedDetails.middleName ??
                                              userDetails.middleName ??
                                              ""
                                            : userDetails.middleName ?? ""
                                        }
                                        color="primary"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "middleName",
                                            e.target ? e.target.value : e
                                          )
                                        }
                                        state={!isEditing}
                                        special={true}
                                      ></TextFieldComp>
                                      {fieldErrors.middleName && (
                                    <div style={{ color: "#dc3545", fontSize: 12, marginTop: 6 }}>
                                       {fieldErrors.middleName}
                                     </div>
                                   )}
                                    </Grid>

                                    {/* Last Name Container */}
                                    <Grid
                                      size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 4,
                                        xl: 4,
                                      }}
                                      item
                                    >
                                      {/* Last Name */}
                                      <TextFieldComp
                                        id="lastName"
                                        label="Last Name"
                                        type="text"
                                        value={
                                          isEditing
                                            ? editedDetails.lastName ??
                                              userDetails.lastName ??
                                              ""
                                            : userDetails.lastName ?? ""
                                        }
                                        color="primary"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "lastName",
                                            e.target ? e.target.value : e
                                          )
                                        }
                                        state={!isEditing}
                                        special={true}
                                      ></TextFieldComp>
                                      {fieldErrors.lastName && (
                                     <div style={{ color: "#dc3545", fontSize: 12, marginTop: 6 }}>
                                       {fieldErrors.lastName}
                                     </div>
                                   )}
                                    </Grid>

                                    {/* Email Address Container */}
                                    <Grid
                                      size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 8,
                                        xl: 8,
                                      }}
                                      item
                                    >
      <Box 
        textAlign="start"
        sx={{ 
          display: "flex", 
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
        }}>
        {/* TextField Container */}
        <Stack direction="column"
        sx={{
          width: "100%"
        }}>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              justifyContent="space-between"
              mb={0.5}>

            {/* Text */}
            <Typography variant="h3" sx={styleText}>
                Email Address
            </Typography>

            {userDetails && userDetails.pendingEmailChange && (

            <button
                                                    onClick={
                                                      handleResendEmailChangeVerification
                                                    }
                                                    disabled={
                                                      resendCooldown > 0
                                                    }
                                                    style={{
                                                      background: "transparent",
                                                      border: "none",
                                                      color:
                                                        resendCooldown > 0
                                                          ? "#999"
                                                          : "#C29E38",
                                                      fontSize: "13px",
                                                      fontWeight: 600,
                                                      cursor:
                                                        resendCooldown > 0
                                                          ? "not-allowed"
                                                          : "pointer",
                                                      textDecoration:
                                                        "underline",
                                                      padding: "4px 8px",
                                                      borderRadius: "4px",
                                                      transition:
                                                        "all 0.2s ease",
                                                      opacity:
                                                        resendCooldown > 0
                                                          ? 0.6
                                                          : 1,
                                                    }}
                                                  >
                                                    {resendCooldown > 0
                                                      ? `Resend (${resendCooldown}s)`
                                                      : "Resend Verification"}
                                                  </button>
            )}

            </Stack>
      {userDetails && userDetails.pendingEmailChange ? (
        <>
<TextField
  id="profile-email-input"
  type="email"
  value={userDetails?.email || ""}
  variant="outlined"
  color="primary"
  FormHelperTextProps={{
    sx: { color: 'error.main' }
  }}
  InputProps={{
    readOnly: true,
    endAdornment: (
      <Box>
<Tooltip
  title={tooltipContent}
  placement="top-end"
  arrow
  open={showTooltip}
  onClose={handleTooltipClose}
  disableFocusListener
  disableHoverListener
  disableTouchListener
  slotProps={{
    // popper: {
      sx: {
        zIndex: 0
      }
    // }
  }}
><Box
        sx={{
          borderLeft: "2px solid rgba(166, 139, 110, 0.4)",
          height: "100%"
        }}>
      <InputAdornment
      tabIndex={0}
        position="end" 
        sx={{ 
          pointerEvents: "auto",
          alignItems: "center"
        }}>
                <Tooltip
        title={!showTooltip ? "Important":
                  null
                }
        placement="top"
        arrow
      >
          <Box
            onClick={() => setShowTooltip(true)}
              alignItems="center"
              sx={{
                cursor: "pointer",
                width: "40px",
                height: "40px",
                borderRadius: "50px",
              }}
            >
      
          <Icon
            src={require("../../../../assets/icons/warning.png")}
            size="small"
          />
          </Box>
          </Tooltip>
      </InputAdornment>
      </Box>
      </Tooltip>
      </Box>
    ),
    sx: {
      borderRadius: '10px',
      fontSize: '14px',
      color: "rgba(44, 37, 30, .7)",
      backgroundColor: "rgba(194, 158, 56, .3)",
      '& input': {
        color: "rgba(44, 37, 30, 0.8)",
        pointerEvents: "none", // Only the input is non-interactive
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: "#C29E38",
        borderWidth: '2px',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: "#C29E38",
      },
      '&:hover': {
        bgcolor: "none",
      },
    },
  }}
  inputProps={{
    tabIndex: -1,
    readOnly: true,
  }}
  onChange={(e) =>
    handleInputChange(
      "email",
      e.target ? e.target.value : e
    )
  }
  sx={{
    width: '100%',
    borderRadius: '10px',
  }}
/>
</>
      ) : (
        <>
<TextField
  id="profile-email-input"
  type="email"
  value={userDetails?.email || ""}
  variant="outlined"
  color="primary"
  FormHelperTextProps={{
    sx: { color: 'error.main'}
  }}
  InputProps={{
    readOnly: true,
    endAdornment: (
      <Box
        display={
          isEditing ? "flex" : "none"
        }>
      <Tooltip
        title={
          userDetails?.email ? "Change Email Address" : "Add Email Address"
        }
        placement="top"
        arrow
      ><Box
        sx={{
          borderLeft: "2px solid rgba(166, 139, 110, 0.4)",
          height: "100%"
        }}>
      <InputAdornment
      tabIndex={0}
        position="end" 
        sx={{ 
          // backgroundColor: "cadetblue",
          pointerEvents: isEditing ? "auto": "none" 
        }}>
      
        <button
          type="button"
          tabIndex={0}
          onClick={() => {
            setNewEmailInput("");
            setEmailChangePassword("");
            setEmailValidationErrors({
              email: "",
              password: "",
            });
            setShowEmailChangeModal(true);
          }}
          style={{
            borderRadius: "50px",
            width: "40px",
            height: "40px",
            pointerEvents: isEditing ? "auto": "none" ,
          
          "&:hover": { backgroundColor: "#a68b6e33",},
          }}
        >
          <Icon
            src={require("../../../../assets/icons/change_email.png")}
            size="small"
          />
        </button>
      </InputAdornment>
      </Box>
      </Tooltip>
      </Box>
    ),
    sx: {
      cursor: isEditing ? "not-allowed" : "default",
      borderRadius: '10px',
      fontSize: '14px',
      color: "rgba(44, 37, 30, .7)",
      backgroundColor: (true || isEditing) ? "#f4f4f4" : "#ffffff",
      '& input': {
        color: (true || isEditing) ? "#666666" : undefined,
        pointerEvents: "none", // Only the input is non-interactive
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: "rgba(222, 171, 120, 0.4)",
        borderWidth: '2px',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: "rgba(44, 37, 30, .4)",
      },
      '&:hover': {
        bgcolor: "none",
      },
    },
  }}
  inputProps={{
    tabIndex: -1,
    readOnly: true,
  }}
  onChange={(e) =>
    handleInputChange(
      "email",
      e.target ? e.target.value : e
    )
  }
  sx={{
    width: '100%',
    borderRadius: '10px',
  }}
/>
</>
      )}

            </Stack>
        
        </Box>

                                    </Grid>

                                    {/* Mobile Number Container */}
                                    <Grid
                                      size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 4,
                                        xl: 4,
                                      }}
                                      item
                                    >
                                      {/* Mobile Number */}
                                      <TextFieldComp
                                        id="contactNumber"
                                        label="Mobile Number"
                                        type="text"
                                        value={
                                          isEditing
                                            ? editedDetails.contactNumber ??
                                              userDetails.contactNumber ??
                                              "N/A"
                                            : userDetails.contactNumber ?? "N/A"
                                        }
                                        color="primary"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "contactNumber",
                                            e.target ? e.target.value : e
                                          )
                                        }
                                        state={!isEditing}
                                        special={true}
                                      ></TextFieldComp>
                                       {fieldErrors.contactNumber && (
                                       <div style={{ color: "#dc3545", fontSize: 12, marginTop: 6 }}>
                                         {fieldErrors.contactNumber}
                                       </div>
                                     )}
                                    </Grid>

                                    {/* Birthdate Container */}
                                    <Grid
                                      size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 4,
                                        xl: 4,
                                      }}
                                      item
                                    >
                                      {/* Birthdate */}
                                      <TextFieldComp
                                        id="birthDate"
                                        label="Birthday"
                                        type="text"
                                        value={
                                          userDetails.birthDate
                                            ? formatDateMMDDYYYY(
                                                userDetails.birthDate
                                              )
                                            : "N/A"
                                        }
                                        color="primary"
                                        // onChange={setEmail}
                                        state={true}
                                        // check={noInput}
                                        special={true}
                                        style={{
                                          background: isEditing ? "#f4f4f4" : "#ffffff",
                                          color: isEditing ? "#666" : undefined,
                                        }}
                                        nonClickable={true}               // keep birthday non-clickable even while editing
                                       inputProps={{ readOnly: true }}
                                      ></TextFieldComp>
                                    </Grid>

                                  {/* Civil Status Container */}
                                   <Grid
                                      size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 4,
                                        xl: 4,
                                      }}
                                      item
                                    >

                      <Box textAlign="start">
                        {/* TextField Container */}
                        <Stack direction="column">
                          {/* Text */}
                          <Typography variant="h3" sx={styleTextSelect}>
                            Civil Status
                          </Typography>

                          <FormControl
                                  sx={{
                                    minWidth: "100px",
                                    height: "53px"
                                  }}
                                >
                                  <Selected
                                    maxWidth
                                    value={
                                                isEditing
                                                  ? editedDetails.civilStatus ?? userDetails?.civilStatus ?? "Single"
                                                  : userDetails?.civilStatus ?? "N/A"
                                              }
                                    onChange={(e) =>
                                                handleInputChange("civilStatus", e.target.value)
                                              }
                                    sx={{
                                      height: "53px",
                                      // maxWidth: "100%",
                                      backgroundColor: isEditing ? "#ffffff" : "#f4f4f4",
                                      fontSize: "14px",
                                      "& .MuiSelect-select": {
                                        padding: "10px 15px",
                                        color: isEditing ? "#2C251E" : "#666666",
                                      },
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        border:
                                          "2px solid rgba(197,165,114,0.4)",
                                        borderRadius: "8px",
                                      },
                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "rgba(197,165,114,0.9)",
                                        },
                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "rgba(197,165,114,1)",
                                        },
                                      "& .MuiSvgIcon-root": {
                                        color: "#2C251E",
                                      },
                                    }}
                                    MenuProps={{
                                      PaperProps: {
                                        sx: {
                                          backgroundColor: "#FEFEFE",
                                          color: "#2C251E",
                                          borderRadius: "10px",
                                          marginTop: "10px",
                                          border:
                                            "1.5px solid rgba(197,165,114,0.6)",

                                          "& .MuiMenuItem-root": {
                                            fontSize: "14px",
                                            borderRadius: "6px",
                                            "&:hover": {
                                              backgroundColor:
                                                "rgba(197,165,114,0.2)",
                                            },
                                          },

                                          "& .MuiMenuItem-root.Mui-selected, & .MuiMenuItem-root.Mui-selected:hover":
                                            {
                                              backgroundColor:
                                                "rgba(44,37,30,0.9) !important",
                                              color: "#FEFEFE !important",
                                              borderRadius: "0px !important",
                                              "& .MuiListItemButton-root": {
                                                borderRadius: "0px !important",
                                              },
                                            },

                                          "& .MuiList-root .Mui-selected": {
                                            borderRadius: "0px !important",
                                          },

                                          "& .MuiMenuItem-root:first-of-type": {
                                            borderTopLeftRadius: "6px",
                                            borderTopRightRadius: "6px",
                                          },

                                          "& .MuiMenuItem-root:last-of-type": {
                                            borderBottomLeftRadius: "6px",
                                            borderBottomRightRadius: "6px",
                                          },
                                        },
                                      },
                                    }}
                                  >
                                    <MenuItem value="Single">Single</MenuItem>
                                    <MenuItem value="Married">Married</MenuItem>
                                    <MenuItem value="Widowed">Widowed</MenuItem>
                                    <MenuItem value="Divorced">Divorced</MenuItem>
                                    <MenuItem value="Separated">Separated</MenuItem>
                                  </Selected>
                                </FormControl>
                        </Stack>
                      </Box>
                                    </Grid>

                                  {/* Gender Container */}
                                   <Grid
                                      size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 4,
                                        xl: 4,
                                      }}
                                      item
                                    >

                      <Box textAlign="start">
                        {/* TextField Container */}
                        <Stack direction="column">
                          {/* Text */}
                          <Typography variant="h3" sx={styleTextSelect}>
                            Gender
                          </Typography>

                          <FormControl
                                  sx={{
                                    minWidth: "100px",
                                    height: "53px"
                                  }}
                                >
                                  <Selected
                                    maxWidth
                                    value={
                                                isEditing
                                                  ? editedDetails.gender ?? userDetails?.gender ?? "Single"
                                                  : userDetails?.gender ?? "N/A"
                                              }
                                    onChange={(e) =>
                                                handleInputChange("gender", e.target.value)
                                              }
                                    sx={{
                                      height: "53px",
                                      // maxWidth: "100%",
                                      backgroundColor: isEditing ? "#ffffff" : "#f4f4f4",
                                      fontSize: "14px",
                                      "& .MuiSelect-select": {
                                        padding: "10px 15px",
                                        color: isEditing ? "#2C251E" : "#666666",
                                      },
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        border:
                                          "2px solid rgba(197,165,114,0.4)",
                                        borderRadius: "8px",
                                      },
                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "rgba(197,165,114,0.9)",
                                        },
                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "rgba(197,165,114,1)",
                                        },
                                      "& .MuiSvgIcon-root": {
                                        color: "#2C251E",
                                      },
                                    }}
                                    MenuProps={{
                                      PaperProps: {
                                        sx: {
                                          backgroundColor: "#FEFEFE",
                                          color: "#2C251E",
                                          borderRadius: "10px",
                                          marginTop: "10px",
                                          border:
                                            "1.5px solid rgba(197,165,114,0.6)",

                                          "& .MuiMenuItem-root": {
                                            fontSize: "14px",
                                            borderRadius: "6px",
                                            "&:hover": {
                                              backgroundColor:
                                                "rgba(197,165,114,0.2)",
                                            },
                                          },

                                          "& .MuiMenuItem-root.Mui-selected, & .MuiMenuItem-root.Mui-selected:hover":
                                            {
                                              backgroundColor:
                                                "rgba(44,37,30,0.9) !important",
                                              color: "#FEFEFE !important",
                                              borderRadius: "0px !important",
                                              "& .MuiListItemButton-root": {
                                                borderRadius: "0px !important",
                                              },
                                            },

                                          "& .MuiList-root .Mui-selected": {
                                            borderRadius: "0px !important",
                                          },

                                          "& .MuiMenuItem-root:first-of-type": {
                                            borderTopLeftRadius: "6px",
                                            borderTopRightRadius: "6px",
                                          },

                                          "& .MuiMenuItem-root:last-of-type": {
                                            borderBottomLeftRadius: "6px",
                                            borderBottomRightRadius: "6px",
                                          },
                                        },
                                      },
                                    }}
                                  >
                                    <MenuItem value="Male">Male</MenuItem>
                                    <MenuItem value="Female">Female</MenuItem>
                                    <MenuItem value="Other">Other</MenuItem>
                                  </Selected>
                                </FormControl>
                        </Stack>
                      </Box>
                                    </Grid>

                                    {/* Address Container */}
                                    <Grid
                                      size={{
                                        xs: 12,
                                        sm: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                      }}
                                      item
                                    >
                                      {/* Address */}
                                      <TextFieldComp
                                        id="address"
                                        label="Address"
                                        type="text"
                                        value={
                                          isEditing
                                            ? editedDetails.address ??
                                              userDetails.address ??
                                              "N/A"
                                            : userDetails.address ?? "N/A"
                                        }
                                        color="primary"
                                        onChange={(e) =>
                                          handleInputChange(
                                            "address",
                                            e.target ? e.target.value : e
                                          )
                                        }
                                        state={!isEditing}
                                        special={true}
                                      ></TextFieldComp>
                                    </Grid>
                                  </Grid>
                                </div>
                              ) : (
                                <p>Loading profile information...</p>
                              )}
                            </Box>
                          </Grid>

                          {/* Edit Profile Button */}
                          <Grid
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            item
                          >
                            {/* Main Content */}
                            <Box
                              sx={{
                                width: "100%",
                                // backgroundColor: "#81735fff",
                              }}
                            >
                              {/* Edit Profile Buttons */}
                              <div
                               className="allow-click"
                               style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                {isEditing && (
                                  <Button
                                    onClick={handleSave}
                                    disabled={isProfileSaving}
                                    sx={{
                                      background: "#C5A572",
                                      color: "#FDF9F3",
                                      border: "1px solid #C5A572",
                                      padding: "10px 20px",
                                      cursor: isProfileSaving ? "not-allowed" : "pointer",
                                      borderRadius: "5px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "8px",
                                      textTransform: "none",
                                      fontWeight: "bold",
                                      fontSize: "14px",
                                      "&:hover": {
                                        backgroundColor: "#B8955A",
                                        borderColor: "#B8955A",
                                      },
                                      "&:disabled": {
                                        backgroundColor: "#E0D6C3",
                                        borderColor: "#E0D6C3",
                                        color: "#999",
                                      },
                                    }}
                                  >
                                    {isProfileSaving ? (
                                      <>
                                        <CircularProgress size={16} sx={{ color: "#FDF9F3" }} />
                                        <span>Saving...</span>
                                      </>
                                    ) : (
                                      "Save"
                                    )}
                                  </Button>
                                )}

                                <Button
                                  variant={isEditing ? "outlined" : "contained"}
                                  onClick={async () => {
                                    if (isEditing) {
                                      setIsProfileCanceling(true);
                                      // Add a small delay to show loading state
                                      await new Promise(resolve => setTimeout(resolve, 300));
                                      setEditedDetails({}); // Reset edits on cancel
                                      setFieldErrors({ // Clear all field errors on cancel
                                        firstName: "",
                                        middleName: "",
                                        lastName: "",
                                        contactNumber: "",
                                      });
                                      setIsProfileCanceling(false);
                                    } else {
                                      setIsProfileEditing(true);
                                      // Add a small delay to show loading state
                                      await new Promise(resolve => setTimeout(resolve, 300));
                                      setIsProfileEditing(false);
                                    }
                                    setIsEditing(!isEditing);
                                  }}
                                  disabled={isProfileCanceling || isProfileEditing}
                                  sx={{
                                    padding: "10px 20px",
                                    cursor: (isProfileCanceling || isProfileEditing) ? "not-allowed" : "pointer",
                                    borderRadius: "5px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px",
                                    textTransform: "none",
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                    // Outlined variant (Cancel) styling
                                    ...(isEditing && {
                                      color: "#C5A572",
                                      borderColor: "#C5A572",
                                      "&:hover": {
                                        backgroundColor: "#C5A572",
                                        color: "#FDF9F3",
                                        borderColor: "#C5A572",
                                      },
                                      "&:disabled": {
                                        backgroundColor: "transparent",
                                        borderColor: "#E0D6C3",
                                        color: "#999",
                                      },
                                    }),
                                    // Contained variant (Edit Profile) styling
                                    ...(!isEditing && {
                                      backgroundColor: "#C5A572",
                                      color: "#FDF9F3",
                                      "&:hover": {
                                        backgroundColor: "#B8955A",
                                      },
                                      "&:disabled": {
                                        backgroundColor: "#E0D6C3",
                                        color: "#999",
                                      },
                                    }),
                                  }}
                                >
                                  {isProfileCanceling ? (
                                    <>
                                      <CircularProgress size={16} sx={{ color: isEditing ? "#C5A572" : "#FDF9F3" }} />
                                      <span>Canceling...</span>
                                    </>
                                  ) : isProfileEditing ? (
                                    <>
                                      <CircularProgress size={16} sx={{ color: "#C5A572" }} />
                                      <span>Loading...</span>
                                    </>
                                  ) : (
                                    isEditing ? "Cancel" : "Edit Profile"
                                  )}
                                </Button>
                              </div>
                            </Box>
                          </Grid>
                        </Grid>
</Grid>
</Grid>
</Stack>


                      {/* Profile Information */}
                      {!userDetails ? (
                        <p>Loading profile information...</p>
                      ) : (null)}
                    </Box>
                  </CustomTabPanel>


                  <CustomTabPanel value={value} index={1}>
                    
                    <Stack
                      direction="column"
                      spacing={2}
                      sx={{
                        padding: "5px",
                    }}>
                      <Grid
                        container
                        // rowSpacing={2}
                        // columnSpacing={2}
                        sx={{
                          width: "100%",
                          // height: "100vh",
                          // backgroundColor: "blue",
                          padding: "20px",
                          backgroundColor: "#FEFEFE",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                          borderRadius: 3,
                          "& .MuiGrid-item": {
                            display: "flex",
                            justifyContent: "center",
                            // backgroundColor: "blue",
                          },
                        }}
                      >

                        <Stack
                          direction="column"
                          sx={{
                            width: "100%",
                        }}>

                          <Stack
                              direction="column"
                              justifyContent="flex-start"
                              spacing={1}
                          >
                            <Text
                              text="Two-Factor Authentication"
                              variant="headerh2"
                            />

                            <Text
                              text="The codes will additionally protect your account from hacking."
                              variant="body1"
                            />

                          </Stack>

                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="flex-end"
                            sx={{
                              mt: 2,
                              width: "100%",
                              "@media (max-width:385px)": {
                                flexDirection: "column"
                              },
                            }}
                          >
                            <Stack
                              direction="row"
                              alignContent={"center"}
                              alignItems={"center"}
                              sx={{
                                width: "100%",
                                "@media (max-width:385px)": {
                                  justifyContent: "flex-start"
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.25)",
                                  borderRadius: "10px",
                                  width: "50px",
                                  height: "50px",
                                }}>
                                <Icon
                                  src={require("../../../../assets/email.png")}
                                  size="medium"
                                />
                              </Box>
                              <Stack
                                direction="column"
                              >

                                <Text
                                  text="Email"
                                  variant="historyService"
                                />

                                <Text
                                  text={userDetails?.email || "No email address"}
                                  variant="settingsEmail"
                                />

                              </Stack>

                            </Stack>

                            <FormGroup
                              justifyContent="flex-end"
                              sx={{
                                margin: "0 0 0 0",
                              }}
                            >
                              <FormControlLabel
                                control={
                                  <Switch 
                                    checked={twoFactorEnabled} 
                                    onChange={async () => {
                                      const newValue = !twoFactorEnabled;
                                      setTwoFactorEnabled(newValue);
                                      
                                      if (user) {
                                      try {
                                        setIs2FASaving(true);
                                        
                                        // Add a small delay to show loading state
                                        await new Promise(resolve => setTimeout(resolve, 500));
                                        
                                        // If enabling 2FA, automatically use email as method
                                        if (newValue) {
                                        // Automatically set email as the method (it's the only option)
                                        const methodsToUse = isEmailVerified() ? ["email"] : [];
                                        
                                        if (methodsToUse.length === 0) {
                                          setIs2FASaving(false);
                                          return;
                                        }

                                        // Store the pending methods change for verification
                                        setPending2FAMethod(methodsToUse);
                                        // Show 2FA modal for verification - settings will be saved AFTER successful verification
                                        setShow2FAModal(true);
                                        setIs2FASaving(false);
                                        } else {
                                        // If disabling 2FA, clear method selection and save directly
                                        // If user had a pending enable (modal open but not completed), cancel it
                                        setShow2FAModal(false);
                                        setPending2FAMethod(null);
                                        const userRef = doc(db, "users", user.uid);
                                        await updateDoc(userRef, {
                                          twoFactorEnabled: false,
                                          twoFactorMethod: null,
                                        });

                                        // Update local state
                                        setUserDetails((prev) => ({
                                          ...prev,
                                          twoFactorEnabled: false,
                                          twoFactorMethod: null,
                                        }));

                                        // Clear the method selection in UI
                                        setTwoFactorMethods([]);

                                        // Update original values to reflect the new state
                                        setOriginalTwoFactorEnabled(false);
                                        setOriginalTwoFactorMethods([]);

                                        // Show snackbar only if 2FA was actually enabled before
                                        const wasActuallyEnabled =
                                          originalTwoFactorEnabled || !!userDetails?.twoFactorEnabled;
                                        if (wasActuallyEnabled) {
                                          setTwoFASnackbarMessage("Two-factor authentication Disabled");
                                          setShow2FASnackbar(true);
                                        }

                                        // Force refresh user details to ensure state is in sync
                                        setTimeout(() => {
                                          loadUserDetails(user.uid);
                                        }, 1000);
                                        setIs2FASaving(false);
                                        }
                                      } catch (error) {
                                        console.error("Error saving 2FA settings:", error);
                                        setErrorModal({
                                        isOpen: true,
                                        message: "Failed to save Two-Factor Authentication settings. Please try again.",
                                        });
                                        setIs2FASaving(false);
                                      }
                                      }
                                    }}
                                  />
                                }
                                label={twoFactorEnabled ? "Enabled" : "Disabled"}
                                labelPlacement="bottom"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    fontSize: "11px",
                                    margin: "0 0 0 0",
                                  },
                                }}
                              />
                            </FormGroup>
                          </Stack>
                        </Stack>
                      </Grid>
                          
                      {/* Change pass */}
                      <Grid
                        container
                        // rowSpacing={2}
                        // columnSpacing={2}
                        sx={{
                          width: "100%",
                          // height: "100vh",
                          // backgroundColor: "blue",
                          padding: "20px",
                          backgroundColor: "#FEFEFE",
                          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                          borderRadius: 3,
                          "& .MuiGrid-item": {
                            display: "flex",
                            justifyContent: "center",
                            // backgroundColor: "blue",
                          },
                        }}
                      >

                      <Stack
                        direction="row"
                        sx={{
                          alignItems: "center",
                          width: "100%",
                          justifyContent: "space-between"
                        }}>

                        <Stack
                          direction="column"
                          spacing={1}>
                            
                            <Text
                              text="Change Password"
                              variant="headerh2"
                            />

                            <Text
                              text="Changing your password frequently will additionally protect your account from hacking."
                              variant="body1"
                            />

                        </Stack>

                      </Stack>
                      <Grid
                        size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }}
                        item
                      >

                      <Stack
                        direction="row"
                        sx={{
                          width: "100%",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: 2,
                        }}>


                    <Box
                      style={{ width: "100%",}}>
                      {/* New Password and Confirm Password */}
                        <form
                          onSubmit={async (e) => {
                            e.preventDefault();

                            // Mark all fields as touched on submit to show validation errors
                            setTouchedFields({
                              currentPassword: true,
                              newPassword: true,
                              confirmPassword: true
                            });

                            // Check for empty fields first - set errors immediately
                            if (!currentPassword.trim()) {
                              setCurrentPasswordAuthError("Current password is required");
                              const el = document.querySelector('input[type="password"]');
                              el && el.focus();
                              return;
                            }

                            if (!newPassword.trim()) {
                              setNewPasswordFieldError("New password is required");
                              const inputs = Array.from(document.querySelectorAll('input[type="password"]'));
                              inputs[1] && inputs[1].focus();
                              return;
                            }

                            if (!confirmPassword.trim()) {
                              setConfirmPasswordFieldError("Confirm password is required");
                              const inputs = Array.from(document.querySelectorAll('input[type="password"]'));
                              inputs[2] && inputs[2].focus();
                              return;
                            }

                            // Clear any previous errors
                            setCurrentPasswordAuthError("");

                            // Check validation errors (computed values will update automatically)
                            // For empty fields, we need to compute errors here
                            const finalNewPasswordError = !newPassword.trim() 
                              ? "New password is required" 
                              : newPasswordError;
                            
                            const finalConfirmPasswordError = !confirmPassword.trim()
                              ? "Confirm password is required"
                              : confirmPasswordError;

                            // If there are validation errors, set them in state and return
                            if (finalNewPasswordError || finalConfirmPasswordError) {
                              // Set errors in state so they display
                              if (finalNewPasswordError) {
                                setNewPasswordFieldError(finalNewPasswordError);
                              }
                              if (finalConfirmPasswordError) {
                                setConfirmPasswordFieldError(finalConfirmPasswordError);
                              }
                              // Focus first invalid field
                              if (finalNewPasswordError) {
                                const inputs = Array.from(document.querySelectorAll('input[type="password"]'));
                                inputs[1] && inputs[1].focus();
                              } else if (finalConfirmPasswordError) {
                                const inputs = Array.from(document.querySelectorAll('input[type="password"]'));
                                inputs[2] && inputs[2].focus();
                              }
                              return;
                            }

                            if (!user) {
                              // exceptional: not signed in → keep modal alert for this case
                              setErrorModal({
                                isOpen: true,
                                message: "Not signed in.",
                              });
                              return;
                            }

                            // Attempt reauth + update; Firebase errors are handled below
                            try {
                              setIsPasswordSaving(true);
                              const credential = EmailAuthProvider.credential(
                                user.email,
                                currentPassword
                              );
                              await reauthenticateWithCredential(
                                user,
                                credential
                              );
                              await updatePassword(user, newPassword);

                              // Show snackbar instead of modal
                              setShowPasswordUpdateSnackbar(true);
                              setNewPassword("");
                              setConfirmPassword("");
                              setCurrentPassword("");
                              // Clear all error states
                              setCurrentPasswordAuthError("");
                              setNewPasswordFieldError("");
                              setConfirmPasswordFieldError("");
                            } catch (error) {
                              const code = error?.code || "";
                              const msg = error?.message || "";
                              // Map firebase errors to user-friendly messages
                              if (
                                code === "auth/wrong-password" ||
                                code === "auth/invalid-credential" ||
                                /wrong-password|invalid-credential/i.test(msg)
                              ) {
                                // show inline message under current password input instead of modal
                                setCurrentPasswordAuthError(
                                  "Password is incorrect"
                                );
                              } else if (code === "auth/weak-password") {
                                setErrorModal({
                                  isOpen: true,
                                  message:
                                    "New password is too weak. It must meet the password policy.",
                                });
                              } else {
                                setErrorModal({
                                  isOpen: true,
                                  message:
                                    "Failed to update password. " +
                                    (msg || code),
                                });
                              }
                            } finally {
                              setIsPasswordSaving(false);
                            }
                          }}
                          style={{margin: "0 0 0 0", width: "100%"}}
                        >

                      {/* <TextFieldComp
                        id="change-password"
                        label="Current Password"
                        type={showCurrentPassword ? "text" : "password"}
                        requires={true}
                        value={currentPassword}
                        maxLength={100}
                        onChange={(e) => {
                                  setCurrentPassword(e.target.value);
                                  setCurrentPasswordAuthError("");
                                }}
                        onBlur={() => handleBlur("userPassword")}
                        error={touched.userPassword && errors.userPassword}
                        helperText={touched.userPassword && errors.userPassword}
                        showPasswordToggle={true}
                        showPassword={showPassword}
                        onTogglePassword={() => setShowPassword(!showPassword)}
                      /> */}

                  {/* TextField Password Container*/}
                  <TextFieldCompV2
                    id="change-password"
                    label="Current Password"
                    type={showCurrentPassword ? "text" : "password"}
                    value={currentPassword}
                    color="primary"
                    showPasswordToggle={true}
                    showPassword={showCurrentPassword}
                    onTogglePassword={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setShowCurrentPassword(!showCurrentPassword);
                                }}
                    onChange={(e) => {
                                  setCurrentPassword(e.target.value);
                                  setCurrentPasswordAuthError("");
                                }}
                    onBlur={() => {
                      setTouchedFields(prev => ({ ...prev, currentPassword: true }));
                      // Show required error on blur if field is empty
                      if (!currentPassword.trim()) {
                        setCurrentPasswordAuthError("Current password is required");
                      }
                    }}
                    state={false}
                    requires={true}
                    check={currentPasswordAuthError || (touchedFields.currentPassword && !currentPassword.trim() ? "Current password is required" : "")}/>

                  {/* TextField Password Container*/}
                  <TextFieldCompV2
                    id="change-password"
                    label="New Password"
                    type={showNewPassword ? "text" : "password"}
                    value={newPassword}
                    color="primary"
                    showPasswordToggle={true}
                    showPassword={showNewPassword}
                    onTogglePassword={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setShowNewPassword(!showNewPassword);
                                }}
                    onChange={(e) => {
                                  setNewPassword(e.target.value);
                                  setNewPasswordFieldError("");
                                  // Clear confirm password error if new password changes
                                  if (confirmPasswordFieldError && e.target.value === confirmPassword) {
                                    setConfirmPasswordFieldError("");
                                  }
                                }}
                    onBlur={() => {
                      setTouchedFields(prev => ({ ...prev, newPassword: true }));
                      // Show required error on blur if field is empty
                      if (!newPassword.trim()) {
                        setNewPasswordFieldError("New password is required");
                      }
                    }}
                    state={false}
                    requires={true}
                    check={newPasswordFieldError || newPasswordError}/>

                  {/* TextField Password Container*/}
                  <TextFieldCompV2
                    id="change-password"
                    label="Confirm Password"
                    type={showConfirmPassword ? "text" : "password"}
                    value={confirmPassword}
                    color="primary"
                    showPasswordToggle={true}
                    showPassword={showConfirmPassword}
                    onTogglePassword={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setShowConfirmPassword(!showConfirmPassword);
                                }}
                    onChange={(e) => {
                                  setConfirmPassword(e.target.value);
                                  setConfirmPasswordFieldError("");
                                }}
                    onBlur={() => {
                      setTouchedFields(prev => ({ ...prev, confirmPassword: true }));
                      // Show required error on blur if field is empty
                      if (!confirmPassword.trim()) {
                        setConfirmPasswordFieldError("Confirm password is required");
                      }
                    }}
                    state={false}
                    requires={true}
                    check={confirmPasswordFieldError || confirmPasswordError}/>

                          <div style={{ position: "relative" }}>
                            <Button
                            type="submit"
                              variant="contained"
                              disabled={isPasswordSaving}
                              sx={{
                                width: "100%",
                                height: "40px", // Match input field height
                                padding: "8px 12px", // Match input field padding more precisely
                                border: "1px solid #C5A572",
                              borderRadius: "5px",
                                marginTop: "5px",
                                marginLeft: "0",
                                marginRight: "0",
                                textTransform: "none",
                              fontWeight: "bold",
                                fontSize: "14px",
                                backgroundColor: "#C5A572",
                                color: "#FDF9F3",
                                minHeight: "40px", // Ensure minimum height matches input
                                boxSizing: "border-box", // Include border in width calculation
                                display: "block",
                                "&:hover": {
                                  backgroundColor: "#B8955A",
                                  borderColor: "#B8955A",
                                },
                                "&:disabled": {
                                  backgroundColor: "#E0D6C3",
                                  borderColor: "#E0D6C3",
                                  color: "#999",
                                },
                              }}
                            >
                              {isPasswordSaving ? (
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1 }}>
                                  <CircularProgress size={20} sx={{ color: "#FDF9F3" }} />
                                  <span>Saving...</span>
                                </Box>
                              ) : (
                                "Save Changes"
                              )}
                          </Button>
                          </div>
                        </form>
                      

                      {/* Delete Account Section - For all users */}
                      <div
                        style={{
                          marginTop: "40px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          onClick={handleDeleteAccount}
                          variant="outlined"
                          sx={{
                            color: "#C94D34",
                            borderColor: "#C94D34",
                            padding: "10px 22px",
                            borderRadius: "5px",
                            fontSize: "14px",
                            fontWeight: 600,
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor: "rgba(201, 77, 52, 0.08)",
                              borderColor: "#A93F28",
                            },
                          }}
                        >
                          Delete Account
                        </Button>
                      </div>
                    </Box>
                      
                      </Stack>

                        
                    </Grid>
                    
                      </Grid>
                    </Stack>
                  </CustomTabPanel>
                </Box>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Success Message Snackbar */}
      <Snackbar
        open={showSuccessMessage}
        autoHideDuration={3000}
        onClose={() => {
          setShowSuccessMessage(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => {
            setShowSuccessMessage(false);
          }}
          severity="success"
          variant="filled"
          icon={false}
          sx={{
            backgroundColor: "#558363",
            color: "#fff",
            fontWeight: 600,
            letterSpacing: 0.2,
            borderRadius: "12px",
            padding: "8px 16px",
            minWidth: "auto",
            width: "auto",
            boxShadow: "0 12px 24px rgba(0,0,0,0.18)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
          }}
        >
          Profile updated successfully!
        </MuiAlert>
      </Snackbar>

      {/* 2FA Success Snackbar */}
      <Snackbar
        open={show2FASnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShow2FASnackbar(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => {
            setShow2FASnackbar(false);
          }}
          severity="success"
          variant="filled"
          icon={false}
          sx={{
            backgroundColor: "#558363",
            color: "#fff",
            fontWeight: 600,
            letterSpacing: 0.2,
            borderRadius: "12px",
            padding: "8px 16px",
            minWidth: "auto",
            width: "auto",
            boxShadow: "0 12px 24px rgba(0,0,0,0.18)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
          }}
        >
          {twoFASnackbarMessage}
        </MuiAlert>
      </Snackbar>

      {/* Email Verification Success Snackbar */}
      <Snackbar
        open={showEmailVerificationSnackbar}
        autoHideDuration={5000}
        onClose={() => {
          setShowEmailVerificationSnackbar(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => {
            setShowEmailVerificationSnackbar(false);
          }}
          severity="success"
          variant="filled"
          icon={false}
          sx={{
            backgroundColor: "#558363",
            color: "#fff",
            fontWeight: 600,
            letterSpacing: 0.2,
            borderRadius: "12px",
            padding: "8px 16px",
            minWidth: "auto",
            width: "auto",
            maxWidth: "90vw",
            boxShadow: "0 12px 24px rgba(0,0,0,0.18)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            whiteSpace: "nowrap",
            "& .MuiAlert-message": {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }
          }}
        >
          {emailVerificationSnackbarMessage}
        </MuiAlert>
      </Snackbar>

      {/* Password Update Success Snackbar */}
      <Snackbar
        open={showPasswordUpdateSnackbar}
        autoHideDuration={5000}
        onClose={() => {
          setShowPasswordUpdateSnackbar(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => {
            setShowPasswordUpdateSnackbar(false);
          }}
          severity="success"
          variant="filled"
          icon={false}
          sx={{
            backgroundColor: "#558363",
            color: "#fff",
            fontWeight: 600,
            letterSpacing: 0.2,
            borderRadius: "12px",
            padding: "8px 16px",
            minWidth: "auto",
            width: "auto",
            boxShadow: "0 12px 24px rgba(0,0,0,0.18)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
          }}
        >
          Password updated successfully!
        </MuiAlert>
      </Snackbar>

      {/* Delete Account Error Snackbar */}
      <Snackbar
        open={showDeleteAccountErrorSnackbar}
        autoHideDuration={5000}
        onClose={() => {
          setShowDeleteAccountErrorSnackbar(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => {
            setShowDeleteAccountErrorSnackbar(false);
          }}
          severity="error"
          variant="filled"
          icon={false}
          sx={{
            backgroundColor: "#9F4223",
            color: "#fff",
            fontWeight: 600,
            letterSpacing: 0.2,
            borderRadius: "12px",
            padding: "8px 16px",
            minWidth: "auto",
            width: "auto",
            boxShadow: "0 12px 24px rgba(0,0,0,0.18)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
          }}
        >
          Failed to delete account
        </MuiAlert>
      </Snackbar>

      {/* Delete Request Success Snackbar */}
      <Snackbar
        open={showDeleteRequestSuccessSnackbar}
        autoHideDuration={6000}
        onClose={() => {
          setShowDeleteRequestSuccessSnackbar(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => {
            setShowDeleteRequestSuccessSnackbar(false);
          }}
          severity="success"
          variant="filled"
          icon={false}
          sx={{
            backgroundColor: "#558363",
            color: "#fff",
            fontWeight: 600,
            letterSpacing: 0.2,
            borderRadius: "12px",
            padding: "8px 16px",
            minWidth: "auto",
            width: "auto",
            boxShadow: "0 12px 24px rgba(0,0,0,0.18)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
          }}
        >
          Account deletion request submitted. Awaiting approval from Dentist Owner.
        </MuiAlert>
      </Snackbar>

      {/* Pending Request Snackbar */}
      <Snackbar
        open={showPendingRequestSnackbar}
        autoHideDuration={6000}
        onClose={() => {
          setShowPendingRequestSnackbar(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => {
            setShowPendingRequestSnackbar(false);
          }}
          severity="warning"
          variant="filled"
          icon={false}
          sx={{
            backgroundColor: "#ffc107",
            color: "#212529",
            fontWeight: 600,
            letterSpacing: 0.2,
            borderRadius: "12px",
            padding: "8px 16px",
            minWidth: "auto",
            width: "auto",
            boxShadow: "0 12px 24px rgba(0,0,0,0.18)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center"
          }}
        >
          You already have a pending account deletion request. Please wait for approval.
        </MuiAlert>
      </Snackbar>

      {/* Alert Message */}
      <AlertComp
        message="Are you sure you want to remove your profile picture?"
        title="Remove Profile Picture?"
        isOpen={deleteModalConfig.isOpen}
        image="info"
        type="remove"
        button="Yes, Remove"
        buttonType={false}
        destination="none"
        onConfirm={handleConfirmDelete}
        onClose={closeDeleteModal}
      />

      {/* 2FA Verification Modal */}
      <TwoFactorModal
        isOpen={show2FAModal}
        onClose={() => {
          setShow2FAModal(false);
          setPending2FAMethod(null); // Reset pending method change
        }}
        onSuccess={async () => {
          setShow2FAModal(false);

          // Save 2FA settings to database AFTER successful verification
          try {
            const userRef = doc(db, "users", user.uid);
            await updateDoc(userRef, {
              twoFactorEnabled: true,
              twoFactorMethod: pending2FAMethod.join(","), // Store multiple methods as comma-separated string
            });

            // Update local state with the verified methods
            setUserDetails((prev) => ({
              ...prev,
              twoFactorEnabled: true,
              twoFactorMethod: pending2FAMethod.join(","),
            }));

            // Update the current methods state to match the saved methods
            setTwoFactorMethods(pending2FAMethod);

            // Update original values to reflect the new state
            setOriginalTwoFactorEnabled(true);
            setOriginalTwoFactorMethods([...pending2FAMethod]);

            // Show snackbar instead of modal
            setTwoFASnackbarMessage("Two-factor authentication Enabled");
            setShow2FASnackbar(true);

            // Clear pending method
            setPending2FAMethod(null);

            // Force refresh user details to ensure state is in sync
            setTimeout(() => {
            loadUserDetails(user.uid);
            }, 1000);
          } catch (error) {
            console.error(
              "Error saving 2FA settings after verification:",
              error
            );
            setErrorModal({
              isOpen: true,
              message:
                "Two-Factor Authentication verification successful, but failed to save settings. Please try again.",
            });
          }
        }}
        userId={user?.uid}
        userDetails={{
          ...userDetails,
          twoFactorMethod: (pending2FAMethod || twoFactorMethods).join(","),
        }}
        methods={pending2FAMethod || twoFactorMethods}
        requireInitialSend={true}
      />

      <Modal
        isOpen={showReauthModal}
        onRequestClose={handleReauthCancel}
        contentLabel="Mobile Number Change Confirmation"
        style={{
          overlay: {
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          },
          content: {
            position: "relative",
            border: "none",
            borderRadius: "8px",
            padding: "30px",
            maxWidth: "450px",
            width: "90%",
            margin: "0 auto",
            textAlign: "left",
          },
        }}
      >
        <div>
          <div
            style={{
              position: "relative",
              background: "rgb(253, 249, 243)",
              padding: "16px 24px",
              margin: "-30px -30px 0 -30px",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                margin: 0,
                color: "#2C251E",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              Mobile Number Change Confirmation
            </h3>
            <IconButton
              onClick={handleReauthCancel}
              size="small"
              sx={{
                position: "absolute",
                right: 16,
                top: "50%",
                transform: "translateY(-50%)",
                width: 28,
                height: 28,
                border: "1px solid rgba(44,37,30,0.06)",
                bgcolor: "#fff",
                color: "#2E2D2D",
                fontSize: "16px",
                "&:hover": { bgcolor: "#C5A572", color: "#FEFEFE" },
              }}
              aria-label="close"
            >
              ✕
            </IconButton>
          </div>

          <form onSubmit={handleReauthSubmit} style={{ paddingTop: "24px" }}>
            <div style={{ marginBottom: 16, textAlign: "left" }}>
              <label style={{ fontWeight: "600", fontSize: 13 }}>
                Enter Your Password <span style={{ color: "#f44336" }}>*</span>
              </label>
              <div style={{ position: "relative" }}>
                <input
                  type={showReauthPassword ? "text" : "password"}
                  value={reauthPassword}
                  onChange={(e) => {
                    setReauthPassword(e.target.value);
                    if (reauthPasswordError) setReauthPasswordError("");
                  }}
                  style={{
                    width: "100%",
                    padding: "12px 40px 12px 12px",
                    marginTop: 6,
                    border: reauthPasswordError ? "1px solid #dc3545" : "1px solid #ddd",
                    borderRadius: 6,
                    boxSizing: "border-box",
                  }}
                  autoFocus
                />
                {reauthPassword && (
                  <button
                    type="button"
                    onClick={() => setShowReauthPassword(!showReauthPassword)}
                    aria-label={showReauthPassword ? "Hide password" : "Show password"}
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                      color: "#2C251E",
                    }}
                  >
                    {showReauthPassword ? <Visibility /> : <VisibilityOff />}
                  </button>
                )}
              </div>
              {reauthPasswordError && (
                <div
                  style={{
                    color: "#dc3545",
                    fontSize: "12px",
                    marginTop: "4px",
                    fontWeight: "500",
                  }}
                >
                  {reauthPasswordError}
                </div>
              )}
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                type="submit"
                style={{
                  padding: "10px 20px",
                  background: "#C5A572",
                  color: "#fff",
                  border: "none",
                  borderRadius: 6,
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "500",
                  width: "100%",
                }}
              >
                Confirm
              </button>
            </div>
          </form>
        </div>
      </Modal>

      {/* Success Modal */}
      <Dialog
        key={successModal.isOpen ? 'open' : 'closed'}
        open={successModal.isOpen}
        onClose={() => {
          setSuccessModal({
            isOpen: false,
            message: "",
            title: "",
            verificationMethod: "",
          });
        }}
        maxWidth="xs"
        fullWidth={false}
        sx={{
          zIndex: 1300, // Higher than default MUI Dialog z-index
          "& .MuiDialog-paper": {
            width: "auto",
            minWidth: "320px",
            maxWidth: "400px",
          }
        }}
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          }
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontSize: "20px",
            fontWeight: 600,
            color: successModal.title === "Two-Factor Authentication Enabled" ? "#28a745" : "#C5A572",
            padding: "20px 20px 6px 20px",
            lineHeight: 1.2,
          }}
        >
          {successModal.title || "Email Verification Required"}
        </DialogTitle>
        
          {successModal.verificationMethod && (
          <DialogContent sx={{ textAlign: "center", padding: "2px 20px 8px 20px" }}>
            <div
              style={{
                color: successModal.verificationMethod === "Disabled" ? "#d32f2f" : "#C5A572",
                fontSize: "14px",
                fontWeight: 500,
                opacity: 0.8,
              }}
            >
              Verification Method: {successModal.verificationMethod}
            </div>
          </DialogContent>
        )}
        
        <DialogActions sx={{ justifyContent: "center", padding: "12px 20px 20px 20px" }}>
          <Button
            onClick={() => {
              setIsOKButtonLoading(true);
              setTimeout(() => {
              setSuccessModal({
                isOpen: false,
                message: "",
                  title: "",
                verificationMethod: "",
                });
                setIsOKButtonLoading(false);
              }, 500);
            }}
            disabled={isOKButtonLoading}
            variant="contained"
            sx={{
              backgroundColor: isOKButtonLoading ? "#E0D6C3" : "#C5A572",
              color: isOKButtonLoading ? "#999" : "#FDF9F3",
              fontWeight: 600,
              padding: "8px 24px",
              borderRadius: 2,
              textTransform: "none",
              fontSize: "14px",
              "&:hover": {
                backgroundColor: isOKButtonLoading ? "#E0D6C3" : "#B8955A",
              },
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
          >
            {isOKButtonLoading ? (
              <>
                <CircularProgress size={16} sx={{ color: "#999" }} />
                <span>OK</span>
              </>
            ) : (
              "OK"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Error Modal */}
      <Modal
        isOpen={errorModal.isOpen}
        onRequestClose={() => setErrorModal({ isOpen: false, message: "" })}
        contentLabel="Error"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          },
          content: {
            position: "relative",
            top: "auto",
            left: "auto",
            right: "auto",
            bottom: "auto",
            border: "none",
            borderRadius: "8px",
            padding: "30px",
            maxWidth: "400px",
            width: "90%",
            margin: "0 auto",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            textAlign: "center",
          },
        }}
      >
        <div style={{ textAlign: "center" }}>
          <h2
            style={{
              marginBottom: "15px",
              color: "#dc3545",
              fontSize: "24px",
              fontWeight: "bold",
            }}
          >
            Error
          </h2>
          <p
            style={{
              marginBottom: "25px",
              color: "#666",
              fontSize: "16px",
            }}
          >
            {errorModal.message}
          </p>
          <button
            onClick={() => setErrorModal({ isOpen: false, message: "" })}
            style={{
              padding: "12px 30px",
              backgroundColor: "#dc3545",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            OK
          </button>
        </div>
      </Modal>

      {/* Delete Account Confirmation Dialog */}
      <Dialog
        open={showDeleteAccountModal}
        disableEscapeKeyDown
        onClose={() => {
          cancelDeleteAccount();
        }}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            backgroundColor: "#FFFFFF",
            paddingBottom: 2,
          },
        }}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
          },
        }}
      >
        <DialogTitle
          sx={{
            textAlign: "center",
            fontWeight: 700,
            color: "#C94D34",
            fontSize: "22px",
            padding: "28px 32px 12px 32px",
            position: "relative",
          }}
        >
          Delete Account
          <IconButton
            onClick={cancelDeleteAccount}
            disabled={isCancellingDelete || isDeletingAccount}
            sx={{
              position: "absolute",
              right: 16,
              top: 16,
              color: isCancellingDelete ? "#B0A99F" : "#6D6257",
              "&:hover": {
                backgroundColor: isCancellingDelete ? "transparent" : "rgba(109, 98, 87, 0.08)",
              },
            }}
          >
            {isCancellingDelete ? (
              <CircularProgress size={18} sx={{ color: "#B0A99F" }} />
            ) : (
              <Close fontSize="small" />
            )}
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ padding: "0 32px 8px 32px" }}>
          <Stack spacing={2} alignItems="center">
            <Typography
              sx={{
                color: "#2C251E",
                fontSize: "16px",
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              Are you sure you want to delete your account?
            </Typography>
            <Typography
              sx={{
                color: "rgba(44, 37, 30, 0.6)",
                fontSize: "14px",
                textAlign: "center",
              }}
            >
              This action cannot be undone. {(userDetails?.role || userDetails?.userType) === "Patient"
                ? "All your data, including upcoming appointments and treatment images, will be permanently deleted."
                : "Your account will be deleted."}
            </Typography>
          </Stack>
        </DialogContent>

        <DialogActions
          sx={{
            padding: "12px 32px 28px 32px",
            justifyContent: "center",
            gap: 2,
          }}
        >
          <Button
            onClick={cancelDeleteAccount}
            disabled={isCancellingDelete || isDeletingAccount}
            variant="outlined"
            sx={{
              color: isCancellingDelete ? "#B0A99F" : "#6D6257",
              borderColor: isCancellingDelete ? "#D3CBC1" : "#6D6257",
              padding: "10px 22px",
              borderRadius: 20,
              fontSize: "15px",
              fontWeight: 600,
              minWidth: "120px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: isCancellingDelete ? "transparent" : "rgba(109, 98, 87, 0.08)",
                borderColor: isCancellingDelete ? "#D3CBC1" : "#6D6257",
              },
              "&:disabled": {
                borderColor: "#D3CBC1",
                color: "#B0A99F",
              },
            }}
          >
            {isCancellingDelete ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={16} sx={{ color: "#B0A99F" }} />
                <span>Cancelling...</span>
              </Box>
            ) : (
              "No, Cancel"
            )}
          </Button>
          <Button
            onClick={confirmDeleteAccount}
            disabled={isDeletingAccount || isCancellingDelete}
            variant="contained"
            sx={{
              backgroundColor: isDeletingAccount ? "#D3CBC1" : "#C94D34",
              color: "#fff",
              padding: "10px 22px",
              borderRadius: 20,
              fontSize: "15px",
              fontWeight: 600,
              minWidth: "120px",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: isDeletingAccount ? "#D3CBC1" : "#A93F28",
                boxShadow: "none",
              },
              "&:disabled": {
                backgroundColor: "#D3CBC1",
                color: "#F5F1EC",
              },
            }}
          >
            {isDeletingAccount ? (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CircularProgress size={16} sx={{ color: "#fff" }} />
                <span>Deleting...</span>
              </Box>
            ) : (
              "Yes, Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Email Change Modal */}
      <Modal
        isOpen={showEmailChangeModal}
        onRequestClose={handleEmailChangeModalClose}
        contentLabel={userDetails?.email ? "Change Email Address" : "Add Email"}
        style={{
          overlay: {
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          },
          content: {
            position: "relative",
            border: "none",
            borderRadius: "8px",
            padding: "30px",
            maxWidth: "450px",
            width: "90%",
            margin: "0 auto",
            textAlign: "center",
          },
        }}
      >
        <div>
          {/* Header strip to match Add Personnel modal */}
          <div
            style={{
              position: "relative",
              background: "rgb(253, 249, 243)",
              padding: "16px 24px",
              margin: "-30px -30px 0 -30px",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                margin: 0,
                color: "#2C251E",
                fontSize: "20px",
                fontWeight: "bold",
              }}
            >
              {userDetails?.email ? "Change Email Address" : "Add Email"}
            </h3>
            <IconButton
              onClick={handleEmailChangeModalClose}
              size="small"
              sx={{
                position: "absolute",
                right: 16,
                top: "50%",
                transform: "translateY(-50%)",
                width: 28,
                height: 28,
                border: "1px solid rgba(44,37,30,0.06)",
                bgcolor: "#fff",
                color: "#2E2D2D",
                fontSize: "16px",
                "&:hover": { bgcolor: "#C5A572", color: "#FEFEFE" },
              }}
              aria-label="close"
            >
              ✕
            </IconButton>
          </div>

          {/* Content area with 24px top padding */}
          <div style={{ paddingTop: "24px", textAlign: "left" }}>

          <div style={{ marginBottom: "20px", textAlign: "left" }}>
            <label
              style={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#2C251E",
                marginBottom: "8px",
                display: "block",
              }}
            >
              {userDetails?.email ? "New Email Address" : "Enter Email Address"} <span style={{ color: "#f44336" }}>*</span>
            </label>
            <input
              type="email"
              value={newEmailInput}
              onChange={(e) => setNewEmailInput(e.target.value)}
              placeholder={userDetails?.email ? "Enter new email address" : "Enter email address"}
              style={{
                width: "100%",
                padding: "12px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                fontSize: "14px",
                boxSizing: "border-box",
              }}
              autoFocus
            />
            {/* Email validation error message */}
            {emailValidationErrors.email && (
              <div
                style={{
                  color: "#dc3545",
                  fontSize: "12px",
                  marginTop: "4px",
                  fontWeight: "500",
                }}
              >
                {emailValidationErrors.email}
              </div>
            )}
          </div>

          <div style={{ marginBottom: "20px", textAlign: "left" }}>
            <label
              style={{
                fontWeight: "600",
                fontSize: "14px",
                color: "#2C251E",
                marginBottom: "8px",
                display: "block",
              }}
            >
              Enter Your Password <span style={{ color: "#f44336" }}>*</span>
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showEmailChangePassword ? "text" : "password"}
                value={emailChangePassword}
                onChange={(e) => setEmailChangePassword(e.target.value)}
                placeholder="Enter your current password"
                style={{
                  width: "100%",
                  padding: "12px 40px 12px 12px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  fontSize: "14px",
                  boxSizing: "border-box",
                }}
              />
              {emailChangePassword && (
                <button
                  type="button"
                  onClick={() => setShowEmailChangePassword(!showEmailChangePassword)}
                  aria-label={showEmailChangePassword ? "Hide password" : "Show password"}
                  style={{
                    position: "absolute",
                    right: "8px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    color: "#2C251E",
                  }}
                >
                  {showEmailChangePassword ? <Visibility /> : <VisibilityOff />}
                </button>
              )}
            </div>
            {/* Password validation error message */}
            {emailValidationErrors.password && (
              <div
                style={{
                  color: "#dc3545",
                  fontSize: "12px",
                  marginTop: "4px",
                  fontWeight: "500",
                }}
              >
                {emailValidationErrors.password}
              </div>
            )}
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <button
              type="button"
              onClick={handleEmailChangeSubmit}
              style={{
                padding: "10px 20px",
                background: "#C5A572",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
                width: "100%",
              }}
            >
              {userDetails?.email ? "Change Email" : "Add Email"}
            </button>
          </div>

          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Settings;
